const fr = {
  startStopAdmin: {
    nRecords1: "{{n}} enregistrement",
    tNFields1: "{{n}} champ",
    totMapF1: "distance routière de {{n}} tronçon",
    tAttachTitle: "Pièces jointes / photos",
    stStopped: "Terminé",
    stStarted: "Démarré",
    stPending: "En attente",
    stMissing: "En attente · non fait",
    allStatuses: "Tous les statuts",
    allDepots: "Tous les dépôts",
    allRoutes: "Toutes les routes",
    allEmployees: "Tous les employés",
    clear: "Effacer",
    search: "Rechercher…",
    nRecords: "{{n}} enregistrements",
    noRecords: "Aucun enregistrement",
    title: "Enregistrements Start-Stop",
    subtitle: "Cliquez sur une ligne : positions, carte, distances et photos",
    kTotal: "Total tournées",
    kMissing: "Obligatoire, non fait",
    kTimeChanged: "Heure modifiée",
    kOdometer: "Km compteur",
    timeChanged: "Heure modifiée",
    thEmployee: "Employé",
    thDate: "Date",
    thStatus: "Statut",
    thDuration: "Durée",
    details: "Détails",
    corrShort: "corr.",
    loadFailed: "Chargement impossible",
    resetDone: "Enregistrement réinitialisé",
    resetFailed: "Réinitialisation impossible",
    dur: "{{h}}h {{m}}min",
    yes: "Oui",
    no: "Non",
    lgStop: "Arrêts",
    lgRemaining: "Arrêts restants",
    lgPackages: "Colis restants",
    lgPickup: "Enlèvement",
    lgNote: "Note",
    startKm: "Km de départ",
    endKm: "Km d'arrivée",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    pToday: "Aujourd'hui",
    pYesterday: "Hier",
    pLast7: "7 derniers jours",
    pThisWeek: "Cette semaine",
    pLastWeek: "Semaine dernière",
    pThisMonth: "Ce mois-ci",
    pLastMonth: "Mois dernier",
    xDate: "Date",
    xEmployee: "Employé",
    xRoute: "Route",
    xDepot: "Dépôt",
    xStatus: "Statut",
    xRequired: "Obligatoire",
    xStartTime: "Heure Start",
    xStartSent: "Start envoyé",
    xStartKm: "Km Start",
    xStartAddr: "Adresse Start",
    xStartCoord: "Coordonnées Start",
    xStopTime: "Heure Stop",
    xStopSent: "Stop envoyé",
    xStopKm: "Km Stop",
    xStopAddr: "Adresse Stop",
    xStopCoord: "Coordonnées Stop",
    xTotalKm: "Km total",
    xDuration: "Durée (min)",
    xCorrected: "Corrigé",
    noStart: "Pas de Start",
    noStop: "Pas de Stop",
    completeStop: "Compléter le Stop",
    edit: "Modifier",
    nextDay: "lendemain",
    byAdminCompleted: "Complété par l'admin",
    byAdminEdited: "Modifié par l'admin",
    sentAt: "Envoyé {{time}} ({{diff}} min)",
    mapFailed: "Impossible de charger la carte",
    computing: "Calcul des distances…",
    noCorrections: "Aucune correction",
    adminStopCompleted: "Admin · Stop complété",
    reason: "Motif",
    lat: "Latitude",
    lng: "Longitude",
    address: "Adresse",
    corrected: "corrigé",
    nReminders: "{{n}} rappels",
    kmOdo: "{{km}} km compteur",
    windowClosed: "Délai de Stop dépassé ({{at}}). Le chauffeur ne peut plus faire Stop ; clôturez avec « Compléter le Stop ».",
    secRoute: "Itinéraire et distances",
    secFiles: "Photos & documents ({{n}})",
    none: "Aucun",
    secCorrections: "Historique des corrections",
    noDepotLoc: "Aucune position définie pour <b>{{depot}}</b>. Modifiez le dépôt dans Planification → Dépôts et ajoutez une position pour calculer Dépôt→Start et Stop→Dépôt.",
    depot: "Dépôt",
    legDepotStart: "Dépôt → Premier Start",
    legOdo: "Start → Stop (compteur)",
    legOdoSub: "Km arrivée − Km départ",
    onMap: "{{km}} km sur la carte",
    legStopDepot: "Dernier Stop → Dépôt",
    road: "distance routière",
    straight: "à vol d'oiseau (aucune route trouvée)",
    aboutMin: "~{{m}} min",
    totOdo: "Total (compteur + extrémités)",
    totOdoF: "Dépôt→Start + compteur + Stop→Dépôt",
    totOdoOnly: "compteur seul (pas de position du dépôt)",
    totMap: "Total (tout via la carte)",
    totMapF: "distance routière de {{n}} tronçons",
    mapLayer: "Carte / Satellite",
    satellite: "Satellite",
    map: "Carte",
    fullscreen: "Plein écran",
    exitFullscreen: "Quitter le plein écran",
    pinDepot: "DÉPÔT",
    resetTitle: "Réinitialiser",
    resetConfirmTitle: "Réinitialiser cet enregistrement ?",
    resetConfirmBody: "L'enregistrement Start-Stop, ses photos et corrections seront supprimés ; l'employé pourra refaire Start/Stop. Action irréversible.",
    cancel: "Annuler",
    resetYes: "Oui, réinitialiser",
    remBtn: "Rappels",
    remTitle: "Rappels Start-Stop",
    remDesc: "Les chauffeurs sans Start ou Stop reçoivent une notification push.",
    remLoadFailed: "Impossible de charger les paramètres",
    remSaved: "Paramètres de rappel enregistrés",
    remInvalid: "Vérifiez les valeurs (heures 1–24, répétition 15–360 min)",
    saveFailed: "Échec de l'enregistrement",
    remEnabled: "Rappels activés",
    remHours: "Heures après le Start",
    remHoursDesc: "Première notification si ce délai passe sans Stop",
    hours: "heures",
    min: "min",
    remRepeat: "Rappeler une fois de plus",
    remRepeatDesc: "Deuxième notification si toujours pas de Stop",
    remSecond: "Deuxième rappel",
    remSecondDesc: "Minutes après le premier",
    remAdmins: "Résumé aux admins",
    remAdminsDesc: "Après le dernier rappel, les admins reçoivent la liste des chauffeurs sans Stop",
    remEvery: "Vérifié toutes les 5 minutes.",
    save: "Enregistrer",
    saving: "Enregistrement…",
    locInvalid: "La position doit être « latitude, longitude »",
    endTimeRequired: "L'heure de fin est requise",
    reasonMin: "Indiquez un motif (au moins 3 caractères)",
    stopCompleted: "Stop complété",
    recordCorrected: "Enregistrement corrigé",
    editTitleStart: "Modifier les données de Start",
    editTitleStop: "Modifier les données de Stop",
    editDesc: "Les anciennes et nouvelles valeurs sont historisées.",
    locLabel: "Position (latitude, longitude)",
    reasonLabel: "Motif *",
    reasonPh: "ex. Le chauffeur a oublié le Stop, confirmé par téléphone",
    complete: "Compléter",
    tSsMode: "Mode Start-Stop",
    tSsModeDesc: "Un grand bouton Start apparaît sur le tableau de bord ; la tournée se termine par Stop. Choisissez ci-dessous les champs demandés au Start et au Stop.",
    tRequired: "Obligatoire",
    tRequiredDesc: "Le formulaire ne peut être envoyé sans Start/Stop ; les absents apparaissent en rouge dans les enregistrements Start-Stop.",
    tHideForm: "Masquer les autres champs du formulaire",
    tHideFormDesc: "Coché : seuls les écrans Start/Stop. Décoché : les champs « Dans le formulaire » sont remplis à part.",
    tHideRouteReport: "Masquer l'ancien formulaire « Déclarer la tournée »",
    tHideRouteReportDesc: "Coché : les chauffeurs planifiés sur ce modèle ne voient plus l'ancien bouton, seulement Start/Stop.",
    tWindow: "Plage horaire Start-Stop",
    tWindowStart: "Ouverture Start",
    tWindowEnd: "Stop au plus tard",
    tOvernight: "lendemain · tournée de nuit",
    tClear: "effacer",
    tWindowSet: "Le chauffeur peut faire Start/Stop de {{ws}} le jour de l'affectation jusqu'à {{nd}}{{we}}. Ensuite, un admin clôture les tournées ouvertes.",
    tNextDayPrefix: "le lendemain ",
    tWindowEmpty: "Vide : jour d'affectation 00:00–24:00. Pour les tournées de nuit, ex. 20:00 → 10:00 (une fin plus tôt compte pour le lendemain).",
    pFillDepot: "Remplir avec le dépôt",
    pUsesDepot: "Si vide, les coordonnées du dépôt sont utilisées ({{c}})",
    pOpenMap: "Ouvrir sur la carte",
    pPointLabelPh: "ex. Dépôt client Genk",
    pPointLabel: "Nom du lieu (affiché au chauffeur)",
    pCoordsInvalid: "Format invalide. Exemple : 51.17452,5.82870",
    pCoords: "Coordonnées de départ (lat,lng)",
    simToStart: "Trajet dépôt → Start",
    simTour: "En tournée (livraison)",
    simBack: "Retour au dépôt",
    simAtDepot: "Revenu au dépôt",
    simReset: "Revenir au début",
    nMin: "{{m}} min",
    departDepot: "Départ du dépôt",
    returnDepot: "Retour au dépôt",
    workTotal: "Temps de travail total",
    workFormula: "Départ dépôt (Start − trajet dépôt→Start) → retour dépôt (Stop + trajet Stop→dépôt)",
    workEstimated: "Durées de trajet en partie estimées (service d'itinéraire indisponible)",
    workNoDepot: "Pas de coordonnées du dépôt — durée Start→Stop uniquement",
    nfStart: "Rappel Start",
    nfClose: "Heure limite Stop : {{m}} min restantes",
    nfOverdue: "Rappel de Stop en retard",
    noNotifs: "Aucune notification envoyée",
    secNotifs: "Historique des notifications ({{n}})",
    workShort: "Total {{d}}",
    thWork: "Travail total",
    kWork: "Temps de travail total",
    kWorkAvg: "Moy. {{d}} · tournées : {{n}}",
    kWorkNone: "Aucune tournée terminée",
    pTitle: "Heure et lieu de départ fixes",
    pDesc: "L'employé saisit seulement le km et appuie sur Start ; l'heure et le lieu viennent d'ici et ne peuvent pas être modifiés.",
    pDefaultTime: "Heure par défaut du dépôt",
    pDefaultTimeCompany: "Heure par défaut",
    pRouteTimes: "Heure de départ par tournée",
    pUsesDefault: "défaut {{time}}",
    pFree: "libre",
    pLocation: "Lieu de départ fixe (ex. dépôt client)",
    pLocationDesc: "Ce lieu est enregistré au Start ; la position du téléphone est gardée en secours/journal. Le Start fonctionne même sans localisation.",
    pNoCoords: "Aucune coordonnée saisie et le dépôt n'en a pas — la position du téléphone est utilisée.",
    pHint: "Pour les tournées sans heure, l'employé la saisit. Rappels : 5 fois pendant la fenêtre Start, et 60/30/10 min avant l'heure limite du Stop.",
    presetTimeBadge: "Heure fixe · appui {{time}}",
    presetLocBadge: "Lieu de départ fixe",
    deviceLoc: "Position du téléphone (secours)",
    deviceLocNone: "Position du téléphone indisponible",
    remStartPrompts: "Rappel Start (5 fois)",
    remStartPromptsDesc: "Si non démarré, réparti de l'ouverture à l'heure de départ",
    remClose: "Rappel heure limite Stop",
    remCloseDesc: "Si pas de Stop, 60, 30 et 10 min avant l'heure limite",
    tAskStart: "Demandé au Start",
    tAskStop: "Demandé au Stop",
    tNFields: "{{n}} champs",
    tAutoLoc: "La position et l'heure sont toujours relevées automatiquement",
    tNoFields: "Aucun champ pour l'instant",
    tUnnamed: "(sans nom)",
    tKmPhoto: "KM + photo",
    tKmPhotoTitle: "L'employé saisit le km et peut photographier le compteur (facultatif)",
    tRemoveFromPhase: "Retirer de cette phase (retour au formulaire)",
    tAttachMulti: "(multiples)",
    tShow: "Afficher",
    tAddKm: "Ajouter {{label}} (saisie ou photo)",
    tPickExisting: "+ Choisir un champ existant…",
    tNewField: "Ajouter un champ",
    tFieldNamePh: "Nom du champ (ex. Nombre d'arrêts)",
    tAdd: "Ajouter",
    tAllFields: "Tous les champs — où les demander ?",
    tInForm: "Formulaire",
    tTimeLocked: "L'heure est relevée automatiquement sur l'écran Start/Stop",
    tHint: "Un champ n'est demandé qu'à un endroit. Pour un champ KM placé au Start/Stop, l'employé saisit le km et peut photographier le compteur. Les champs horaires ne peuvent pas être déplacés ; Start/Stop relève l'heure.",
    tAtStart: "Au Start",
    tAtStop: "Au Stop",
    ty_text: "Texte",
    ty_number: "Nombre",
    ty_time: "Heure",
    ty_date: "Date",
    ty_photo: "Photo",
    ty_boolean: "Oui/Non",
    ty_select: "Choix",
  },
  startStop: {
    todayBadge: "AUJOURD'HUI",
    tomorrowBadge: "DEMAIN",
    afterStop: "Après le Stop",
    overnight: "Tournée de nuit d'hier · Stop au plus tard {{time}}",
    overnightBadge: "HIER SOIR",
    startOpensAt: "Le Start ouvre à {{time}}",
    stopDeadline: "Stop au plus tard {{time}}",
    nextDay: "(lendemain)",
    windowClosed: "Le délai Start-Stop est dépassé",
    closedManagerCompletes: "Votre responsable clôturera votre tournée.",
    closedInformManager: "Veuillez informer votre responsable.",
    startTour: "Démarrer la tournée",
    required: "obligatoire",
    running: "Tournée en cours",
    startLabel: "Début",
    startKmShort: "Km début",
    photo: "photo",
    finished: "Tournée terminée",
    correctionUsed: "Correction déjà utilisée",
    correctLast: "Corriger les dernières données (1 fois)",
    elapsed: "{{h}} h {{m}} min",
    yes: "Oui",
    no: "Non",
    saveFailed: "Échec de l'enregistrement",
    optional: "(facultatif)",
    noLocStart: "Impossible de démarrer sans localisation",
    noLocStop: "Impossible de terminer sans localisation",
    orPhoto: "(ou photo)",
    missing: "Manquant : {{list}}",
    startKm: "Km de départ",
    endKm: "Km d'arrivée",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    timeHint: "Si vous la modifiez, l'heure réelle d'envoi est aussi enregistrée",
    kmHintStart: "Saisissez-le ou photographiez le compteur avec l'appareil à droite",
    kmHintStop: "Saisissez-le ou photographiez le compteur",
    startedTitle: "Tournée démarrée",
    goodWork: "Bon travail !",
    canClose: "Vous pouvez fermer cet écran. À la fin de la tournée, appuyez ici sur STOP.",
    startTitle: "Démarrer la tournée",
    takePhoto: "Prendre une photo",
    addFile: "Ajouter un fichier",
    attachments: "Pièces jointes",
    attachmentsPhotos: "Pièces jointes / photos",
    endKmLess: "Le km d'arrivée ne peut pas être inférieur au départ ({{km}})",
    filesUploading: "Fichiers en cours d'envoi, patientez",
    savedThanks: "Opération enregistrée, merci !",
    totalKm: "Total {{km}} km",
    recordReceived: "Enregistrement reçu",
    oneCorrection: "En cas d'erreur, vous pouvez corriger une fois.",
    stopTitle: "Terminer la tournée",
    stopSave: "STOP · Enregistrer",
    reasonRequired: "Indiquez le motif de la correction",
    noChange: "Aucune modification",
    correctionSaved: "Correction enregistrée",
    correctTitle: "Corriger les dernières données",
    correctSubtitle: "Une seule correction possible ; elle est enregistrée",
    saveCorrection: "Enregistrer la correction",
    correctionReason: "Motif de la correction *",
    reasonPlaceholder: "ex. km mal saisi",
    okClose: "OK, fermer l'écran",
    geoUnsupported: "Votre appareil ne prend pas en charge la localisation",
    geoDenied: "Autorisation de localisation refusée. Autorisez la localisation pour ce site dans les paramètres du navigateur et réessayez.",
    geoFailed: "Localisation introuvable. Réessayez à l'extérieur.",
    geoOk: "Localisation obtenue",
    presetLocation: "Lieu de départ : {{depot}} (défini)",
    presetTimeHint: "L'heure de départ est fixée par votre responsable",
    refresh: "Actualiser",
    geoRetry: "Réessayer la localisation",
    geoLoading: "Localisation en cours… appuyez sur « Autoriser » si demandé",
    kmPhotoUploaded: "Photo du compteur envoyée",
    photoUploadFailed: "Échec de l'envoi de la photo",
    kmPlaceholder: "ex. 125430",
    kmPhotoTitle: "Photographier le compteur",
    now: "Maintenant",
    photoAdded: "Photo ajoutée · modifier",
    takePhotoFull: "Prendre une photo",
    geoModalTitle: "Impossible d'obtenir votre position",
    geoWaiting: "En attente de la position…",
    geoRequired: "Start / Stop ne peut pas être envoyé sans position.",
    gettingLocation: "Localisation en cours…",
    retry: "Réessayer",
    close: "Fermer",
    overdueTitle: "Avez-vous oublié le Stop ?",
    overdueBody: "Votre tournée est ouverte depuis {{h}} h. Si vous avez fini, appuyez sur Stop.",
    stepsDeniedIos: ["Réglages → Confidentialité → Service de localisation activé", "Réglages → Safari (ou l'app) → Position → « Demander » ou « Autoriser »", "Revenez sur cette page et appuyez sur « Réessayer »"],
    stepsDeniedAndroid: ["Appuyez sur le cadenas dans la barre d'adresse", "Autorisations → Position → « Autoriser »", "Activez la localisation (GPS) du téléphone, puis « Réessayer »"],
    stepsOther: ["Activez la localisation (GPS) du téléphone", "Si vous êtes à l'intérieur, sortez", "Appuyez sur « Réessayer »"],
  },
  common: {
    welcome: "Bienvenue",
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    profile: "Profil",
    settings: "Paramètres",
    security: "Sécurité",
    users: "Utilisateurs",
    firms: "Entreprises",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    yes: "Oui",
    no: "Non",
    clear: "Effacer",
    clearAll: "Tout effacer",
    optional: "optionnel",
    approve: "Approuver",
    reject: "Refuser",
    pending: "En attente",
    active: "Actif",
    year: "Année",
    month: "Mois",
    day: "Jour",
    unknown: "Inconnu",
    firmDistribution: "Répartition des Entreprises",
    rejected: "Refusé",
    search: "Rechercher...",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    back: "Retour",
    next: "Suivant",
    submit: "Soumettre",
    actions: "Actions",
    noData: "Aucune donnée trouvée",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ?",
    auditLogs: "Journal d'audit",
    leaveRequests: "Demandes de congé",
    confirm: "Confirmer",
    confirmation: "Confirmation",
    all: "Tous",
    firm: "Entreprise",
    refresh: "Actualiser",
    total: "Total",
    email: "Adresse e-mail",
    language: "Langue",
    filter: "Filtre",
    clearFilter: "Effacer le filtre",
    close: "Fermer",
    noResults: "Aucun résultat trouvé",
    from: "De",
    to: "À",
    name: "Nom",
    status: "Statut",
    type: "Type",
    date: "Date",
    amount: "Montant",
    description: "Description",
    details: "Détails",
    view: "Voir",
    download: "Télécharger",
    upload: "Téléverser",
    add: "Ajouter",
    remove: "Retirer",
    select: "Sélectionner",
    selected: "Sélectionné",
    none: "Aucun",
    collapseMenu: "Réduire le menu",
    expandMenu: "Développer le menu",
    darkMode: "Mode Sombre",
    lightMode: "Mode Clair",
    colorTheme: "Thème de couleur",
    minutes: "min",
    clearFilters: "Effacer les filtres",
    dateRange: "Plage de dates",
    filters: "Filtres",
    globalSearch: "Rechercher employé ou plaque...",
    lastMonth: "Mois dernier",
    more: "plus",
    page: "Page",
    perPage: "par page",
    period: "Période",
    previous: "Précédent",
    records: "enregistrements",
    refreshed: "Actualisé",
    show: "Afficher",
    showing: "Affichage",
    vehicleBadge: "Véhicule",
    unassigned: "Non attribué",
    allFirms: "Toutes les entreprises",
    selectFirm: "Sélectionner entreprise",
    accessDenied: "Accès refusé",
    document: "Document",
    inactive: "Inactif",
    processing: "En cours...",
    saving: "Enregistrement...",
    sending: "Envoi en cours...",
    deselectAll: "Tout Désélectionner",
    selectAll: "Tout Sélectionner",
    allDepos: "Tous les Dépôts",
    noDepo: "Sans Dépôt",
    reset: "Réinitialiser",
    showSold: "Afficher vendus",
    sold: "VENDU",
    saleDate: "Date de vente",
    saleDateHint: "Si une date de vente est saisie, le véhicule est considéré comme vendu",
    inVehicle: "Dans le véhicule",
    outVehicle: "Hors du véhicule",
    purchaseDate: "Date d'achat",
    saved: "Enregistré",
    addNote: "Ajouter une Note",
    noFilterResults: "Aucun employé trouvé pour les filtres sélectionnés",
    startDate: "Début",
    endDate: "Fin",
  },
  imageCropper: {
    title: "Modifier l'Image",
    selectFile: "Sélectionner un Fichier",
    dragDrop: "Glissez-déposez l'image ici",
    or: "ou",
    preview: "Aperçu",
    reset: "Réinitialiser",
    rotate: "Pivoter",
    changeImage: "Changer l'Image",
    upload: "Télécharger",
    zoom: "Zoom",
    paste: "Coller",
    pasteHint: "Collez avec Ctrl+V",
  },
  documentEditor: {
    dragDropTitle: "Glissez et déposez le document ici",
    supportedFormats: "JPG, PNG, WEBP, PDF pris en charge",
    selectFile: "Sélectionner un fichier",
    pasteFromClipboard: "Coller depuis le presse-papiers",
    pasteHint: "Vous pouvez coller directement depuis le presse-papiers avec Ctrl+V",
    rotateLeft: "Rotation gauche",
    rotateRight: "Rotation droite",
    flipHorizontal: "Retourner horizontalement",
    flipVertical: "Retourner verticalement",
    reset: "Réinitialiser",
    changeImage: "Changer d'image",
    skipEdit: "Télécharger sans Modification",
    cropAndUpload: "Recadrer et Télécharger",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce document ?",
    deleteDocument: "Supprimer le document",
    deleteSuccess: "Document supprimé avec succès",
    processing: "Traitement...",
    save: "Enregistrer",
    saveAndUpload: "Enregistrer et télécharger",
  },
  nav: {
    lockedDates: "Dates bloquées",
    frontendSettings: "Paramètres d'affichage",
    siteSettings: "Paramètres du site",
    myDocuments: "Mes Documents",
    myPayslips: "Mes Fiches de paie",
    myPackages: "Mes Colis",
    myFinance: "Mes Finances",
    personalMenu: "Personnel",
    myNotifications: "Mes Notifications",
    documentManagement: "Gestion des Documents",
    docManagement: "Documents",
    loonbrief: "Téléchargement Fiche de Paie",
    loonbriefList: "Liste des Fiches de Paie",
    pdfUpload: "Télécharger PDF",
    sendNotification: "Envoyer Notification",
    routes: "Itinéraires",
    allRoutes: "Tous les itinéraires",
    routeReports: "Rapports d'itinéraires",
    fuelReports: "Rapport Carburant",
    vehicles: "Mes Véhicules",
    allUsers: "Tous les utilisateurs",
    languages: "Langues",
    databaseBackup: "Sauvegarde de Base de Données",
    postnlCodes: "Codes PostNL",
    planning: "Planification",
    messages: "Messages",
    chat: "Discussion",
    todoList: "Liste de tâches",
    communication: "Communication",
    dpd: "DPD",
    dpdDailySummary: "DPD Résumé Quotidien",
    dpdDriverPerformance: "DPD Performance Coursier",
    dpdConsolidated: "DPD Rapport Consolidé",
    dpdMonthlyInvoice: "DPD Facturation Mensuelle",
    dpdRetourHeatmap: "DPD Carte Thermique Retours",
    dpdSubcoComparison: "DPD Comparaison Subco",
    dpdCourierMapping: "DPD Correspondance Coursier",
    dpdRetourReport: "DPD Rapport Retour",
    dpdFileCategories: "DPD Catégories Fichiers",
    dpdAnalytics: "DPD Analytique & Perspectives",
  },
  fields: {
    firm_id: "Sélection Entreprise",
    date: "Date",
    route_number: "Numéro de Route",
    route_type: "Type de Route",
    rit: "Rit",
    vehicle_plate: "Plaque du Véhicule",
    driver: "Chauffeur",
    copilot: "Copilote",
    km_start: "KM Début",
    km_end: "KM Fin",
    stops: "Arrêts",
    stop_price: "Prix par Arrêt",
    hourly_rate: "Tarif Horaire (€)",
    start_cost: "Coût de Départ (€)",
    start_time: "Heure de Début",
    end_time: "Heure de Fin",
    break_time: "Temps de Pause",
    totaal_excl_btw: "Total HT",
  },
  calcTypes: {
    hours_rate: "Heures × Tarif + Coût de Départ",
    stops_price: "Arrêts × Prix d'Arrêt",
    fixed_rate: "Tarif Fixe + Coût de Départ",
    manual_total: "Coût de Départ = Total",
  },
  fuelReports: {
    title: "Rapport Carburant",
    subtitle: "Rapport de Carburant",
    date: "Date",
    plate: "Plaque",
    tankCard: "Carte Réservoir",
    driver: "Chauffeur",
    liters: "Litres",
    pricePerLiter: "€/Litre",
    total: "Total",
    period: "Période",
    totalRecords: "Enregistrements",
    totalLiters: "Total Litres",
    totalCost: "Coût Total",
    searchPlaceholder: "Rechercher chauffeur, plaque ou carte...",
    add: "Nouvel Enregistrement Carburant",
    edit: "Modifier Enregistrement Carburant",
    importTitle: "Importer depuis Excel",
    startDate: "Date de Début",
    endDate: "Date de Fin",
    notes: "Notes",
    attachments: "Pièces Jointes",
    loadError: "Impossible de charger les données",
    dateAndPlateRequired: "La date et la plaque sont obligatoires",
    updated: "Mis à jour",
    added: "Ajouté",
    errorOccurred: "Une erreur est survenue",
    operationFailed: "Opération échouée",
    deleted: "Supprimé",
    cannotDelete: "Impossible de supprimer",
    fileAndFirmRequired: "Le fichier et l'entreprise sont obligatoires",
    importSuccess: "{{count}} enregistrements importés",
    importFailed: "Importation échouée",
    fileUploaded: "Fichier téléchargé",
    uploadFailed: "Échec du téléchargement",
    fileDeleted: "Fichier supprimé",
    fileTooLarge: "Ne peut pas dépasser 10 Mo",
    fileUploadFailed: "n'a pas pu être téléchargé",
    excelImport: "Importer Excel",
    selectDriver: "Sélectionner un chauffeur",
    searchDriver: "Rechercher et sélectionner un chauffeur...",
    selectFirmFirst: "Sélectionnez d'abord une entreprise",
    searchDriverPlaceholder: "Rechercher un chauffeur...",
    driverNotFound: "Chauffeur non trouvé",
    manualEntry: "ou saisir manuellement",
    servicePartner: "Service Partner",
    clone: "Cloner",
    cloned: "Enregistrement cloné avec la date actuelle",
    noRecords: "Aucun enregistrement trouvé",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
    matched: "Apparié",
    selectPlate: "Sélectionner une plaque",
    searchPlate: "Rechercher plaque...",
    plateNotFound: "Plaque non trouvée",
    addFile: "Ajouter un fichier",
    noAttachments: "Aucune pièce jointe",
    importing: "Importation...",
    import: "Importer",
    manualDriverEntry: "ou saisir le nom du chauffeur",
    dragDropFiles: "Glissez des fichiers ou cliquez pour télécharger",
    delete: "Supprimer",
  },
  loonbrief: {
    title: "Téléchargement Fiche de Paie",
    description: "Distribuez automatiquement les PDF de fiches de paie aux employés",
    uploadSettings: "Paramètres de Téléchargement",
    firm: "Entreprise",
    firmRequired: "Entreprise *",
    selectFirm: "Sélectionner entreprise...",
    period: "Période",
    periodRequired: "Période *",
    selectPeriod: "Sélectionner période...",
    pdfUpload: "Télécharger PDF",
    selectFirmFirst: "Veuillez d'abord sélectionner une entreprise",
    selectPeriodFirst: "Veuillez sélectionner une période",
    processing: "Traitement du PDF en cours, veuillez patienter...",
    processSuccess: "PDF traité",
    processError: "Erreur lors du traitement du PDF",
    matched: "correspondu",
    unmatched: "non correspondu",
    results: "Résultats du Traitement",
    page: "Page",
    nameFromPdf: "Nom du PDF",
    matchedEmployee: "Employé Correspondant",
    status: "Statut",
    action: "Action",
    statusMatched: "Correspondu",
    statusUnmatched: "Non Correspondu",
    statusError: "Erreur",
    manualMatch: "Correspondance Manuelle",
    manualMatchTitle: "Correspondance Manuelle",
    nameInPdf: "Nom dans le PDF:",
    searchEmployee: "Rechercher employé...",
    employeeNotFound: "Employé non trouvé",
    matchSuccess: "correspond à",
    aliases: "Alias",
    naam: "Naam",
    clear: "Effacer",
    saveMatched: "Sauvegarder Correspondances",
    noMatchedToSave: "Aucune fiche de paie correspondante à sauvegarder",
    pdfNotFound: "Fichier PDF non trouvé, veuillez télécharger à nouveau",
    saveSuccess: "fiches de paie sauvegardées avec succès",
    savePartialError: "fiches de paie n'ont pas pu être sauvegardées",
    saveError: "Erreur lors de la sauvegarde",
    employeesLoaded: "employés chargés",
    employeesWithAliases: "employés ont des alias définis",
    cancel: "Annuler",
    saveSummaryTitle: "Résultats de Sauvegarde",
    saveSummaryDesc: "Le processus de sauvegarde des fiches de paie est terminé.",
    summarySaved: "Sauvegardé",
    summaryErrors: "Erreurs",
    summaryUnmatched: "Non correspondant",
    summarySuccessTitle: "Fiches de Paie Sauvegardées avec Succès",
    summaryErrorTitle: "Enregistrements Échoués",
    summaryUnmatchedTitle: "Employés Non Correspondants",
    summaryUpdated: "Mis à jour",
    unmatchedHint: "Ces employés ne sont peut-être pas enregistrés dans le système ou leurs noms peuvent être dans un format différent. Vous pouvez utiliser la correspondance manuelle.",
    close: "Fermer",
  },
  languages: {
    subtitle: "Modifier les traductions du système",
    syncComplete: "Synchronisation terminée !",
    syncCompleteDesc: "{added} nouveaux ajoutés, {updated} mis à jour, {skipped} ignorés",
    syncFailed: "Échec de la synchronisation",
    translationSaved: "Traduction enregistrée dans la base de données",
    translationSaveFailed: "Échec de l'enregistrement de la traduction",
    keyNameRequired: "Le nom de la clé est obligatoire",
    keyAlreadyExists: "Cette clé existe déjà",
    atLeastOneValue: "Saisissez au moins une valeur de traduction",
    newKeyAdded: "Nouvelle clé de traduction ajoutée",
    addKeyFailed: "Échec de l'ajout de la traduction",
    exported: "Traductions exportées",
    invalidFileFormat: "Format de fichier invalide. Le fichier JSON doit avoir la structure {tr: {...}, en: {...}, ...}",
    analysisFailed: "Échec de l'analyse du fichier",
    invalidJson: "Fichier JSON invalide",
    importComplete: "Importation terminée !",
    importCompleteDesc: "{added} nouveaux, {updated} mis à jour, {skipped} ignorés",
    importFailed: "Échec de l'importation",
    cacheCleared: "Cache vidé, retour aux traductions par défaut",
    translationsTab: "Traductions",
    scanTab: "Détection Manquantes",
    scanTitle: "Détection des Clés de Traduction Manquantes",
    scanDescription: "Détecte les clés de traduction utilisées dans le code source mais non définies, et les écarts entre les langues.",
    scanBtn: "Lancer le Scan",
    scanning: "Scan en cours...",
    scanComplete: "Scan terminé",
    scanFailed: "Scan échoué",
    scanKeysScanned: "Scannées dans le Code",
    scanKeysDefined: "Définies dans i18n",
    scanUndefined: "Clé Non Définie",
    scanCrossLang: "Manquante Inter-Langue",
    scanSearchPlaceholder: "Rechercher une clé...",
    allLanguages: "Toutes les Langues",
    undefinedInCode: "Clés Utilisées dans le Code mais Non Définies",
    undefinedInCodeDesc: "Ces clés sont appelées avec t() dans le code source mais ne sont définies dans aucune langue.",
    crossLangMissing: "Clés Manquantes Inter-Langues",
    crossLangMissingDesc: "Ces clés sont définies dans certaines langues mais manquantes dans d'autres.",
    missingInLangs: "Manquante Dans",
    presentInLangs: "Présente Dans",
    allKeysComplete: "Toutes les Clés Complètes !",
    allKeysCompleteDesc: "Toutes les clés de traduction utilisées dans le code sont définies dans toutes les langues.",
    scanPrompt: "Lancez un scan pour détecter les clés de traduction manquantes",
    scanPromptDesc: "Les fichiers de code source seront scannés et comparés avec les définitions i18n.",
    scanningInProgress: "Scan du code source en cours...",
    synced: "Synchronisé",
    syncToDb: "Sync vers DB",
    newKey: "Nouvelle Clé",
    export: "Exporter",
    analyzing: "Analyse...",
    import: "Importer",
    reset: "Réinitialiser",
    missing: "manquant",
    complete: "Complet",
    filteringMissing: "Filtrage des traductions manquantes...",
    searchPlaceholder: "Rechercher clé ou valeur...",
    selectNamespace: "Sélectionner namespace",
    allNamespaces: "Tous les Namespaces",
    perPageSuffix: "/ page",
    allMissing: "Tous Manquants",
    clearFilter: "Effacer le Filtre",
    translationsTitle: "Traductions",
    translationsFound: "traductions trouvées",
    missingFor: "manquants",
    allMissingLabel: "Tous manquants",
    keyColumn: "Clé",
    actionColumn: "Action",
    missingValue: "(manquant)",
    noResults: "Aucun résultat trouvé",
    pageLabel: "Page",
    editTitle: "Modifier la Traduction",
    missingBadge: "Manquant",
    translationPlaceholder: "traduction...",
    cancel: "Annuler",
    saving: "Enregistrement...",
    save: "Enregistrer",
    addTitle: "Ajouter une Nouvelle Clé de Traduction",
    addDescription: "Format de clé : namespace.key (ex : common.newFeature)",
    keyName: "Nom de la Clé",
    keyPlaceholder: "ex : common.addFinancialRecord",
    translationValues: "Valeurs de Traduction",
    adding: "Ajout...",
    add: "Ajouter",
    importPreviewTitle: "Aperçu de l'Importation",
    importPreviewDesc: "Fichier analysé. Les modifications suivantes seront effectuées :",
    willAdd: "Sera Ajouté",
    willUpdate: "Sera Mis à Jour",
    totalKeys: "Total Clés",
    importMode: "Mode d'Importation :",
    modeMerge: "Fusionner (Recommandé)",
    modeSkip: "Ignorer les Existants",
    modeOverwrite: "Écraser",
    modeMergeDesc: "Les valeurs existantes sont préservées, les nouvelles sont ajoutées/mises à jour",
    modeSkipDesc: "Seules les nouvelles clés sont ajoutées, les existantes restent inchangées",
    modeOverwriteDesc: "Toutes les valeurs sont remplacées par le contenu du fichier",
    keysAlreadyExist: "clés existent déjà",
    keysAlreadyExistDesc: "Ces clés seront mises à jour.",
    protectExisting: "mode pour préserver les valeurs existantes.",
    newKeysToAdd: "Nouvelles Clés à Ajouter",
    andMoreKeys: "... et {count} clés de plus",
    keysToUpdate: "Clés à Mettre à Jour",
    existingToNew: "Actuel → Nouvelles valeurs",
    importing: "Importation...",
    syncTitle: "Synchroniser les Traductions vers la Base de Données",
    syncDesc: "Transférez toutes les traductions de i18n.js vers MongoDB. Cette opération ajoute uniquement les clés manquantes et préserve vos modifications.",
    inI18n: "Dans i18n.js",
    inDb: "Dans la BD",
    toBeAdded: "À Ajouter",
    whatDoesThisDo: "Que fait cette opération ?",
    syncInfo1: "Lit toutes les traductions du fichier i18n.js",
    syncInfo2: "Ajoute les clés absentes de la BD",
    syncInfo3: "PRÉSERVE les existantes (ne les écrase pas)",
    syncInfo4: "La BD devient la Source Unique de Vérité",
    dbSynced: "Base de données synchronisée !",
    dbSyncedDesc: "{synced} depuis i18n, {added} ajoutés par les utilisateurs",
    dbNotSynced: "Base de données pas encore synchronisée",
    dbNotSyncedDesc: "Appuyez sur le bouton \"Synchroniser\" pour la configuration initiale",
    syncing: "Synchronisation...",
    syncBtn: "Synchroniser",
  },
  lockedDates: {
    title: "Dates bloquées",
    description: "Gérer les dates où les employés ne peuvent pas demander de congé",
    lockDate: "Bloquer une date",
    howItWorks: "Comment fonctionnent les dates bloquées ?",
    infoLine1: "Les employés ne peuvent pas créer de demandes de congé aux dates bloquées",
    infoLine2: "L'option \"Répéter chaque année\" bloque automatiquement les mêmes dates chaque année",
    infoLine3: "Vous pouvez bloquer des dates pour toutes les entreprises ou des entreprises spécifiques",
    activeLockedDates: "Dates bloquées actives",
    recordsFound: "enregistrements trouvés",
    dates: "Dates",
    reason: "Raison",
    firms: "Entreprises",
    repeat: "Répétition",
    createdBy: "Créé par",
    noLockedDates: "Aucune date bloquée trouvée",
    more: "plus",
    allFirms: "Toutes les entreprises",
    everyYear: "Chaque année",
    oneTime: "Une seule fois",
    addNewTitle: "Ajouter de nouvelles dates bloquées",
    addNewDescription: "Les employés ne pourront pas demander de congé aux dates sélectionnées",
    selectDates: "Sélectionner les dates",
    datesSelected: "dates sélectionnées",
    allFirmsApplies: "S'appliquera à toutes les entreprises",
    firmsSelected: "entreprises sélectionnées",
    reasonPlaceholder: "Ex : Inventaire annuel, Réunion d'entreprise...",
    repeatYearly: "Répéter chaque année",
    repeatYearlyDesc: "Ces dates seront automatiquement bloquées chaque année",
    lockDates: "Bloquer les dates",
    deleteTitle: "Supprimer les dates bloquées",
    deleteConfirm: "Cette action ne peut pas être annulée. Êtes-vous sûr de vouloir supprimer le blocage ?",
    datesCreated: "Dates bloquées créées",
    datesDeleted: "Dates bloquées supprimées",
    calendarView: "Calendrier",
    listView: "Liste",
    calendarTitle: "Calendrier des Dates Bloquées",
    lockedDay: "Jour Bloqué",
    today: "Aujourd'hui",
    lockedRecords: "enregistrements bloqués",
  },
  packages: {
    title: "Colis",
    subtitle: "Données de facturation et de distribution",
    fetchError: "Erreur lors du chargement des colis",
    statsError: "Erreur lors du chargement des statistiques",
    detailError: "Erreur lors du chargement du détail de facture",
    totalInvoices: "Total Factures",
    totalAmount: "Montant Total",
    totalEmployees: "Total Employés",
    totalRegions: "Total Régions",
    totalQuantity: "Quantité Totale",
    overview: "Aperçu",
    invoices: "Factures",
    employees: "Employés",
    regions: "Régions",
    weeklyTrend: "Tendance Hebdomadaire",
    regionDistribution: "Répartition par Région",
    topEmployees: "Employés les Mieux Payés",
    topEmployeesByPackage: "Top Employés par Nombre de Colis",
    invoiceList: "Liste des Factures",
    invoiceNumber: "N° Facture",
    invoiceDate: "Date",
    weekNumber: "Semaine",
    company: "Entreprise",
    location: "Localisation",
    employeeStats: "Statistiques des Employés",
    employeeName: "Employé",
    routeDays: "Routes/Jours Travaillés",
    workDays: "Jours de Travail",
    dailyAverage: "Moyenne Journalière",
    difference: "Diff (165)",
    bonusCalculation: "Calcul de Bonus",
    unitPrice: "Prix Unitaire",
    calculation: "Calcul",
    dayShort: "jours",
    clickToCopy: "Cliquez pour copier",
    copiedToClipboard: "copié",
    totalEarnings: "Total des Gains",
    regionStats: "Statistiques par Région",
    region: "Région",
    employeeCount: "Nombre d'Employés",
    invoiceDetail: "Détail de Facture",
    year: "Année",
    week: "Semaine",
    date: "Date",
    quantity: "Quantité",
    total: "Total",
    searchEmployee: "Rechercher un employé...",
    searchInvoice: "Rechercher une facture...",
    noEmployeeFound: "Aucun employé trouvé pour",
    employeesShown: "employés affichés",
    allCompanies: "Toutes les Entreprises",
    allLocations: "Toutes les Localisations",
    noInvoiceFound: "Aucune facture trouvée pour les filtres",
    invoicesShown: "factures affichées",
    deleteConfirmTitle: "Supprimer la Facture",
    deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer cette facture et toutes les données associées? Cette action est irréversible.",
    deleteSuccess: "Facture supprimée avec succès",
    deleteError: "Erreur lors de la suppression",
    allRegions: "Toutes les Régions",
    allDates: "Toutes les Dates",
    unitPrice: "Prix Unitaire",
    fixedCharge: "Fixe",
    filteredQuantity: "Quantité Filtrée",
    filteredTotal: "Total Filtré",
    regionSummary: "Résumé par Région",
    selected: "sélectionné(s)",
    deleteSelected: "Supprimer la Sélection",
    bulkDeleteTitle: "Suppression en Masse",
    bulkDeleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer ces factures et toutes les données associées?",
    bulkDeleteWarning: "Cette action est irréversible!",
    selectedInvoices: "Factures à Supprimer",
    deleteAll: "Tout Supprimer",
    invoicesDeleted: "factures supprimées avec succès",
    invoicesDeleteError: "factures non supprimées",
    allWeeks: "Toutes les Semaines",
    selectWeeks: "Sélectionner les Semaines",
    selectMonth: "Sélectionner le Mois",
    monthsSelected: "mois sélectionnés",
    amount: "Montant",
    packageCount: "Colis",
    createdAt: "Date de Création",
    amountPerPackage: "Montant Moyen par Colis",
    weeklyYearComparison: "Comparaison Hebdomadaire",
    showingInvoices: "Affichage",
    perPage: "Par page",
    page: "Page",
    yearlyComparison: "Comparaison Annuelle",
    yearlyQuantity: "Quantités Annuelles de Colis",
    driverLocationMatrix: "Matrice de Performance Chauffeur-Localisation",
    driverLocationMatrixDesc: "Voyez comment chaque chauffeur performe à différentes localisations",
    driver: "Chauffeur",
    locationTotal: "Total Localisation",
    showingTopDrivers: "Affichage des meilleurs",
    drivers: "chauffeurs",
    matrixError: "Erreur lors du chargement de la matrice",
    last7Days: "7 Derniers Jours",
    last4Weeks: "4 Dernières Semaines",
    last3Months: "3 Derniers Mois",
    allTime: "Tout le Temps",
    seasonalTrends: "Analyse des Tendances Saisonnières",
    seasonalInsights: "Aperçus Saisonniers",
    monthly: "Mensuel",
    quarterly: "Trimestriel",
    yearOverYearGrowth: "Croissance Annuelle",
    busiestByAmount: "Plus Occupé (Montant)",
    busiestByPackage: "Plus Occupé (Colis)",
    monthlyPattern: "Modèle Mensuel",
    avgQuantity: "Moy. Colis",
    seasonalError: "Erreur lors du chargement des tendances saisonnières",
    last6MonthsVs: "6 Derniers Mois vs Précédent",
    last12MonthsVs: "12 Derniers Mois vs Précédent",
    periodGrowth: "Comparaison de Période",
    totalAmountLabel: "Montant Total",
    totalPackageLabel: "Total Colis",
    amountPerPackageLabel: "Montant par Colis",
    changePercent: "Variation (%)",
    weekLabel: "Semaine",
    dateRange: "Plage de Dates",
    dateRangeFilter: "Filtrer par Plage de Dates",
    startDate: "Début",
    endDate: "Fin",
    clearSelection: "Effacer",
    weeksSelected: "semaines sélectionnées",
    last3Years: "3 Dernières Années",
    last4Years: "4 Dernières Années",
  },
  dashboard: {
    totalApprovedDays: "Total jours approuvés",
    pendingRequests: "Demandes en attente",
    approvedRequests: "Demandes approuvées",
    rejectedRequests: "Demandes refusées",
    monthlyApprovedDays: "Jours de congé approuvés mensuels",
    monthlyWorkStatus: "Statut de travail mensuel",
    approvedDays: "Jours approuvés",
    working: "Travaillé",
    halfDay: "Demi-journée",
    sick: "Malade",
    dop: "Jour de repos",
    onLeave: "En congé",
    recentRequests: "Demandes récentes",
    adjustment: "ajustement",
    statusDistribution: "Répartition des statuts",
    topLeaveTypes: "Types de congé populaires",
    capacityHotspots: "Jours chargés",
    firmComparison: "Comparaison des entreprises",
    myPlanning: "Mon Planning",
    planningLoading: "Chargement du planning...",
    upcomingCount: "{{count}} à venir",
    historyCount: "{{count}} passé(s)",
    viewList: "Liste",
    viewWeek: "Semaine",
    today: "Aujourd'hui",
    noAssignmentToday: "Aucune affectation pour aujourd'hui.",
    nextSevenDays: "7 prochains jours",
    historyWith: "Historique ({{count}})",
    week: "Semaine",
    thisWeek: "Aujourd'hui",
    prevWeek: "Semaine précédente",
    nextWeek: "Semaine suivante",
    weekDaysToggle: "5 ou 7 jours",
    sevenDaysShort: "7 jours",
    fiveDaysShort: "5 jours",
    daysShort: { 0: "Dim", 1: "Lun", 2: "Mar", 3: "Mer", 4: "Jeu", 5: "Ven", 6: "Sam" },
    monthsShort: { 0: "Jan", 1: "Fév", 2: "Mar", 3: "Avr", 4: "Mai", 5: "Jun", 6: "Jul", 7: "Aoû", 8: "Sep", 9: "Oct", 10: "Nov", 11: "Déc" },
    quickActions: "Actions rapides",
    requests: "demandes",
    globalView: "Vue globale",
    allFirms: "Toutes les entreprises",
    activeEmployees: "Employés actifs",
    pendingRegistrations: "Inscriptions en attente",
    todayWorking: "Travaillant aujourd'hui",
    clickToSeeDetails: "Cliquez pour voir les détails",
    todayStatus: "Votre statut aujourd'hui",
    noStatusYet: "Pas encore défini",
    createLeaveHint: "Créez rapidement votre demande de congé",
    workStatusHint: "Consultez votre statut de travail quotidien",
    myRecentRequests: "Mes demandes récentes",
    lastFiveRequests: "Vos 5 dernières demandes",
    viewAll: "Voir tout",
    vehicleWarnings: "Alertes Véhicules",
    critical: "Critique",
    warning: "Avertissement",
    viewAllVehicles: "Voir tout",
    andMoreVehicles: "et {{count}} véhicules de plus...",
    andMorePeople: "et {{count}} personnes de plus... Voir Tout",
    allDocsUpToDate: "Tous les documents sont à jour",
    noExpiringDocs: "Aucun document n'expire dans les 90 prochains jours.",
    expiryAlertSent: "Notification d'expiration envoyée à {count} personnes.",
    noExpiryAlertNeeded: "Personne trouvé pour la notification.",
    sendAlert: "Envoyer Alerte",
    sendAlertError: "Échec de l'envoi de l'alerte",
    checking: "Vérification...",
    checkExpiryTooltip: "Vérifier les documents qui expirent et envoyer des alertes",
    todos: "Tâches",
    noTodos: "Aucune tâche ouverte.",
    markDone: "Terminer",
    lastCheck: "Dernier contrôle",
    expired: "Expiré",
    criticalDays: "Critique (30 jours)",
    warningDays: "Avertissement (90 jours)",
    totalPeople: "Total : {count} personnes",
    insuranceExpired: "Assurance expirée il y a {days} jours !",
    insuranceExpiring: "Assurance expire dans {days} jours",
    inspectionExpired: "Contrôle technique expiré il y a {days} jours !",
    inspectionExpiring: "Contrôle technique expire dans {days} jours",
    maintenanceOverdue: "Entretien en retard de {days} jours !",
    maintenanceUpcoming: "Entretien dans {days} jours",
  },
  forgotPassword: {
    title: "Mot de passe oublié ?",
    subtitle: "Nous enverrons un code de vérification à votre adresse e-mail",
    description: "Entrez votre e-mail et nous vous enverrons un code de vérification.",
    enterEmail: "Entrez votre adresse e-mail",
    invalidEmail: "Entrez une adresse e-mail valide",
    emailPlaceholder: "exemple@entreprise.com",
    emailHint: "Entrez votre adresse e-mail enregistrée. Le code de vérification sera envoyé à cette adresse.",
    sendCode: "Envoyer le code de vérification",
    verifyCode: "Vérifier le code",
    codeSentEmail: "Code de vérification envoyé à votre e-mail",
    enterCode: "Entrez le code de vérification",
    codeExpiry: "Le code expirera dans 10 minutes",
    verify: "Vérifier",
    resendCode: "Renvoyer le code",
    codeResent: "Nouveau code envoyé",
    codeSent: "Code de vérification envoyé",
    codeVerified: "Code vérifié",
    invalidCode: "Code invalide",
    enterValidCode: "Veuillez entrer le code à 6 chiffres",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    newPasswordDesc: "Créez un mot de passe fort avec au moins 6 caractères.",
    resetPassword: "Réinitialiser le mot de passe",
    passwordTooShort: "Le mot de passe doit comporter au moins 6 caractères",
    successTitle: "Mot de passe modifié !",
    successMessage: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    successSubtitle: "Votre mot de passe a été modifié avec succès",
    successDesc: "Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    rememberPassword: "Vous vous souvenez de votre mot de passe ?",
    step1Label: "E-mail",
    step2Label: "Vérification",
    step3Label: "Mot de passe",
    passwordResetSuccess: "Votre mot de passe a été réinitialisé avec succès",
  },
  months: {
    jan: "Jan",
    feb: "Fév",
    mar: "Mar",
    apr: "Avr",
    may: "Mai",
    jun: "Juin",
    jul: "Juil",
    aug: "Août",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Déc",
  },
  auth: {
    email: "E-mail",
    password: "Mot de passe",
    passwordConfirm: "Confirmer le mot de passe",
    fullName: "Nom complet",
    gsm: "Téléphone",
    language: "Langue",
    loginTitle: "Connectez-vous à votre compte",
    registerTitle: "Créer un nouveau compte",
    registerRightTitle: "Rejoignez notre communauté",
    registerRightDesc: "Créez votre compte et commencez à gérer efficacement les demandes de congé.",
    registerSuccessTitle: "Inscription Réussie !",
    registerSuccessMsg: "Votre compte a été créé. Vous pourrez vous connecter après approbation de l'administrateur.",
    pendingApproval: "Votre compte est en attente d'approbation. Veuillez attendre la confirmation de l'administrateur.",
    forgotPassword: "Mot de passe oublié",
    noAccount: "Vous n'avez pas de compte ?",
    hasAccount: "Vous avez déjà un compte ?",
    welcomeBack: "Connectez-vous à votre compte",
    loginSuccess: "Connexion réussie",
    rememberMe: "Se souvenir de moi",
    biometricLogin: "Connexion biométrique",
    biometricNotRegistered: "Aucune identification biométrique trouvée sur cet appareil",
    orBiometric: "ou",
    registerSuccess: "Inscription réussie. Votre compte est en attente d'approbation.",
    invalidCredentials: "E-mail ou mot de passe invalide",
    accountPending: "Votre compte est en attente d'approbation. Veuillez attendre la confirmation de l'administrateur.",
    accountRejected: "Votre compte a été refusé.",
    accountCreated: "Votre compte a été créé avec succès.",
    firmAssignmentPending: "Une fois l'attribution de votre entreprise terminée, le processus d'approbation de votre compte sera finalisé et vous serez notifié.",
    loginAfterApproval: "La connexion ne sera pas possible tant que le processus d'approbation n'est pas terminé.",
    step1: "Informations personnelles",
    step2: "Sécurité",
    invalidResetLink: "Lien de réinitialisation de mot de passe invalide",
    invalidLink: "Lien invalide",
    setNewPassword: "Définir un nouveau mot de passe",
    setNewPasswordDescription: "Définissez un nouveau mot de passe pour votre compte",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    passwordMinLength: "Le mot de passe doit comporter au moins 6 caractères",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    passwordResetSuccess: "Mot de passe modifié avec succès",
    passwordChanged: "Mot de passe modifié",
    passwordResetSuccessMessage: "Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    setPassword: "Définir le mot de passe",
    backToLogin: "Retour à la connexion",
    twoFA: "Authentification à deux facteurs (2FA)",
    twoFAVerification: "Vérification 2FA",
    twoFASetup: "Configuration 2FA",
    twoFAEnabled: "2FA Actif",
    twoFADisabled: "2FA Inactif",
    twoFAActive: "Actif",
    twoFAInactive: "Inactif",
    twoFAProtected: "Votre compte est protégé par l'authentification à deux facteurs",
    twoFAEncourage: "Activez la 2FA pour rendre votre compte plus sécurisé",
    twoFASupportedApps: "Google Authenticator, Microsoft Authenticator, Authy et autres applications TOTP sont pris en charge",
    twoFAEnable: "Activer 2FA",
    twoFADisable: "Désactiver 2FA",
    twoFABackupCodes: "Codes de secours",
    twoFAYourBackupCodes: "Vos codes de secours",
    twoFAScanQR: "Scannez le code QR ci-dessous avec votre application d'authentification :",
    twoFACantScanQR: "Vous ne pouvez pas scanner le code QR ?",
    twoFAScannedNext: "J'ai scanné, continuer",
    twoFAEnterCode: "Entrez le code à 6 chiffres de votre application d'authentification :",
    twoFAVerifyAndEnable: "Vérifier et Activer",
    twoFASaveBackupCodes: "Enregistrez ces codes de secours dans un endroit sûr. Vous pouvez les utiliser pour vous connecter si vous perdez l'accès à votre application d'authentification.",
    twoFACopyCodes: "Copier les codes",
    twoFAComplete: "Terminé",
    twoFADisableConfirm: "Entrez votre mot de passe pour désactiver la 2FA :",
    twoFAYourPassword: "Votre mot de passe",
    twoFACancel: "Annuler",
    twoFARemainingCodes: "Restant : {count} codes",
    twoFACopy: "Copier",
    twoFARegenerate: "Régénérer",
    twoFACopied: "Copié !",
    twoFALoginPrompt: "entrez le code à 6 chiffres de votre application d'authentification",
    twoFALoginBackupPrompt: "entrez votre code de secours",
    twoFAUseBackupCode: "Utiliser un code de secours",
    twoFAUseAuthCode: "Utiliser le code d'authentification",
    twoFABackToLogin: "Retour à la connexion",
    twoFASecureConnection: "Connexion sécurisée établie",
    registrationPending: "Inscription en Attente",
    waitingApproval: "En Attente d'Approbation",
  },
  login: {
    heroTitle: "Gérez efficacement les congés de votre équipe",
    heroDescription: "Simplifiez les demandes de congé, les approbations et le suivi en un seul endroit.",
  },
  leave: {
    annual: "Congé annuel",
    sick: "Congé maladie",
    personal: "Congé personnel",
    paternity: "Congé paternité",
    kleinVerlet: "Petit chômage",
    unpaid: "Congé sans solde",
    total: "Total",
    used: "Utilisé",
    remaining: "Restant",
    entitled: "Accordé",
    request: "Demande de congé",
    requests: "Demandes de congé",
    newRequest: "Créer une nouvelle demande",
    balances: "Soldes de congé",
    days: "jours",
    day: "jour",
    selectYear: "Sélectionner l'année",
    noBalances: "Aucun solde de congé trouvé",
    adjustBalance: "Ajuster le solde",
    adjustmentReason: "Raison de l'ajustement",
    addDays: "Ajouter des jours",
    removeDays: "Retirer des jours",
    adjustmentHistory: "Historique des ajustements",
    requiresDocument: "Document requis",
    leaveTypes: "Types de congé",
    viewBalances: "Voir les soldes",
    previousYears: "Années précédentes",
    createRequest: "Créer une demande de congé",
    selectType: "Sélectionner le type de congé",
    type: "Type de congé",
    selectedType: "Type de congé sélectionné",
    selectDates: "Sélectionner les dates",
    reviewSubmit: "Vérifier et soumettre",
    startDate: "Date de début",
    endDate: "Date de fin",
    description: "Description",
    descriptionPlaceholder: "Ajoutez une note sur votre demande de congé...",
    documentUpload: "Télécharger un document",
    documentOptional: "Le téléchargement de document est optionnel",
    documentRecommended: "Un document est recommandé pour ce type de congé",
    confirmRequest: "Je confirme que cette demande est correcte",
    submitRequest: "Soumettre la demande",
    requestCreated: "Demande de congé créée avec succès",
    requestUpdated: "Demande de congé mise à jour",
    requestCancelled: "Demande de congé annulée",
    requestDeleted: "Demande de congé supprimée",
    deleteRequest: "Supprimer la demande",
    deleteRequestConfirm: "Êtes-vous sûr de vouloir supprimer cette demande de congé ? Cette action est irréversible.",
    noRequests: "Vous n'avez pas encore de demandes de congé",
    cancelRequest: "Annuler la demande",
    editRequest: "Modifier la demande",
    viewDetails: "Voir les détails",
    insufficientBalance: "Solde de congé insuffisant",
    datesOverlap: "Les dates sélectionnées chevauchent une demande de congé existante",
    step1Title: "Étape 1 : Sélectionner le type de congé",
    step2Title: "Étape 2 : Sélectionner les dates",
    selectDaysHint: "Sélectionnez au moins un jour dans le calendrier",
    locked: "Verrouillé",
    blockedDays: "Jours bloqués",
    blockedDaysWarning: "Les dates sélectionnées incluent des jours complets",
    dayFullyBooked: "Ce jour est complet (5+ demandes approuvées)",
    calendarView: "Vue calendrier",
    selectedRange: "Dates sélectionnées",
    pending: "En attente",
    approved: "Approuvé",
    rejected: "Refusé",
    cancelled: "Annulé",
    step1: "Étape 1",
    step2: "Étape 2",
    step3: "Étape 3",
    summary: "Résumé",
    myRequests: "Mes demandes de congé",
    archived: "Archivé",
    selectTypeFirst: "Veuillez d'abord sélectionner un type de congé",
    selectDays: "Veuillez sélectionner au moins un jour",
    noDaysSelected: "Sélectionnez des jours dans le calendrier",
    totalDays: "Total des jours",
    selectedDays: "Jours sélectionnés",
    selectedDates: "Dates sélectionnées",
    selected: "Sélectionné",
    weekend: "Week-end",
    calendarTip: "Cliquez sur le calendrier pour sélectionner les jours de congé souhaités. Cliquez à nouveau pour désélectionner.",
    calendarTipShort: "Cliquez sur les jours pour sélectionner/désélectionner",
    requestedAt: "Date de demande",
    more: "plus",
    daysAvailable: "jours restants",
    maxDays: "Max",
    maxDaysReached: "Vous pouvez sélectionner maximum {days} jours pour ce type de congé",
    selectLeaveTypeFirst: "Sélectionnez d'abord le type de congé",
    selectLeaveTypeFirstDesc: "Vous devez d'abord sélectionner un type de congé ci-dessus pour choisir les dates",
    noRemainingDays: "Aucun jour restant",
    remainingDays: "Jours Restants",
    requestSubmitted: "Demande de congé soumise",
    selectLeaveType: "Sélectionnez le type de congé",
  },
  leaveCalendar: {
    deleteLeave: "Supprimer le congé",
    deleteConfirmTitle: "Supprimer le congé",
    deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer ce congé ?",
    deleteBalanceNote: "Pour les congés approuvés, les jours utilisés seront remis au solde.",
    confirmDelete: "Oui, Supprimer",
    deleteSuccess: "Congé supprimé avec succès",
    deleteError: "Erreur lors de la suppression du congé",
    balanceRestored: "{days} jours remis au solde",
    cannotDeletePast: "Les congés passés ne peuvent pas être supprimés",
    removeThisDay: "Supprimer Seulement Ce Jour",
    removeDayConfirmTitle: "Supprimer Ce Jour",
    removeDayConfirmMessage: "Êtes-vous sûr de vouloir retirer ce jour du congé ?",
    confirmRemoveDay: "Oui, Supprimer Ce Jour",
    deleteEntireLeave: "Supprimer Tout le Congé",
    dayRemovedSuccess: "{date} supprimé du congé",
    removeDayError: "Erreur lors de la suppression du jour",
  },
  admin: {
    userManagement: "Gestion des utilisateurs",
    createUser: "Ajouter un utilisateur",
    createUserDesc: "Ajouter manuellement un nouvel utilisateur au système",
    firmManagement: "Gestion des entreprises",
    pendingApprovals: "Approbations en attente",
    auditLogs: "Journal d'audit",
    statistics: "Statistiques",
    totalUsers: "Total utilisateurs",
    totalFirms: "Total entreprises",
    pendingUsers: "Utilisateurs en attente",
    activeUsers: "Utilisateurs actifs",
    approveUser: "Approuver l'utilisateur",
    rejectUser: "Refuser l'utilisateur",
    rejectReason: "Raison du refus",
    selectFirm: "Sélectionner l'entreprise",
    createFirm: "Nouvelle entreprise",
    firmName: "Nom de l'entreprise",
    firmLogo: "Logo de l'entreprise",
    selectRole: "Sélectionner le rôle",
    roleEmployee: "Employé",
    roleFirmAdmin: "Administrateur d'entreprise",
    confirmApprove: "Êtes-vous sûr de vouloir approuver cet utilisateur ?",
    confirmReject: "Êtes-vous sûr de vouloir refuser cet utilisateur ?",
    approveConfirmation: "Cette action ne peut pas être annulée.",
    rejectConfirmation: "Cette action ne peut pas être annulée.",
    firmRequired: "La sélection de l'entreprise est obligatoire",
    reasonRequired: "La raison du refus est obligatoire (minimum 5 caractères)",
    userApproved: "Utilisateur approuvé avec succès",
    userRejected: "Utilisateur refusé",
    pendingTab: "En attente",
    activeTab: "Actifs",
    rejectedTab: "Refusés",
    createdAt: "Date de création",
    leaveRequestManagement: "Gestion des congés",
    leaveManagement: "Congés",
    listView: "Liste",
    calendarView: "Calendrier",
    approveRequest: "Approuver la demande",
    rejectRequest: "Refuser la demande",
    cancelRequest: "Annuler la demande",
    archiveRequest: "Archiver",
    editRequest: "Modifier",
    confirmApproveLeave: "Êtes-vous sûr de vouloir approuver cette demande de congé ?",
    confirmRejectLeave: "Êtes-vous sûr de vouloir refuser cette demande de congé ?",
    confirmCancelLeave: "Êtes-vous sûr de vouloir annuler cette demande de congé approuvée ?",
    confirmArchiveLeave: "Êtes-vous sûr de vouloir archiver cette demande de congé ?",
    leaveApproved: "Demande de congé approuvée",
    leaveApprovedWithWarnings: "Congé approuvé avec avertissements (Super Admin override)",
    warn: {
      insufficientBalance: "Solde insuffisant : {{requested}} jours demandés, {{available}} disponibles",
      daysFullyBooked: "Ces jours sont complets (5+ approuvés) : {{dates}}",
      lockedDates: "Dates verrouillées : {{dates}}",
      dateOverlap: "Les dates chevauchent une autre demande approuvée",
      noBalance: "Solde de congé non trouvé",
    },
    leaveRejected: "Demande de congé refusée",
    leaveCancelled: "Demande de congé annulée",
    leaveArchived: "Demande de congé archivée",
    leaveUpdated: "Demande de congé mise à jour",
    samePeriodsOnLeave: "Personnel en congé pendant ces dates :",
    overlappingDates: "Dates qui se chevauchent",
    requester: "Demandeur",
    leaveType: "Type de congé",
    dateRange: "Période",
    daysCount: "Nombre de jours",
    requestDate: "Date de demande",
    adminNote: "Note admin",
    adminNotePlaceholder: "Note admin (optionnel)...",
    enterReason: "Entrez la raison",
    notifyUser: "Notifier l'utilisateur",
    notifyBySms: "Par SMS",
    notifyByEmail: "Par e-mail",
    notifyByWhatsapp: "Par WhatsApp",
    balanceInfo: "Info solde",
    capacityWarning: "Avertissement de capacité",
    archivedTab: "Archivés",
    allRequests: "Toutes les demandes",
    approveLeaveConfirmation: "Vous êtes sur le point d'approuver cette demande de congé.",
    rejectReasonRequired: "La raison du refus est obligatoire",
    deleteUser: "Supprimer l'utilisateur",
    confirmDeleteUser: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    userDeleted: "Utilisateur supprimé",
    deleteWarning: "Cette action ne peut pas être annulée !",
    deleteLeaveRequest: "Supprimer la demande de congé",
    confirmDeleteLeaveRequest: "Êtes-vous sûr de vouloir supprimer définitivement cette demande de congé ?",
    leaveRequestDeleted: "Demande de congé supprimée",
    hardDelete: "Suppression Forcée",
    hardDeleteTitle: "Suppression Forcée (Super Admin)",
    hardDeleteWarning: "Ceci contourne TOUTES les validations et supprime définitivement la demande de congé. Le solde NE sera PAS restauré. Les anciens enregistrements peuvent aussi être supprimés.",
    hardDeleteConfirmPrompt: "Tapez HARDSIL en majuscules pour confirmer:",
    hardDeleteConfirmWord: "HARDSIL",
    hardDeleteConfirmButton: "Oui, Forcer la Suppression",
    hardDeleteSuccess: "Demande de congé supprimée de force",
    hardDeleteTooltip: "Suppression Forcée: contourne toutes les règles (Super Admin uniquement)",
    frontendSettings: "Paramètres du site",
    frontendSettingsDescription: "Gérer l'apparence de la page d'accueil, de connexion et d'inscription",
    siteName: "Nom du site",
    siteNameDesc: "Modifier le titre et le nom de marque de l'application",
    siteNameLabel: "Nom du site",
    siteNameHelp: "Ce nom apparaît dans la barre de navigation, le titre et le pied de page",
    landingPageToggle: "Contrôle de la page d'accueil",
    landingPageToggleDesc: "Contrôler la visibilité de la page d'accueil",
    enableLandingPage: "Activer la page d'accueil",
    landingPageNote: "Lorsque désactivé, les utilisateurs sont directement redirigés vers la page de connexion",
    landingDisabledWarning: "Page d'accueil désactivée. Les utilisateurs seront directement redirigés vers la page de connexion.",
    pageImages: "Images des pages",
    pageImagesDesc: "Définir les images d'arrière-plan des pages",
    landingPageImage: "Image de la page d'accueil",
    loginPageImage: "Image de la page de connexion",
    registerPageImage: "Image de la page d'inscription",
    settingsSaved: "Paramètres enregistrés",
    superAdminRequired: "Les droits de Super Admin sont requis pour accéder à cette page",
    searchUsers: "Rechercher par nom, e-mail ou téléphone...",
    allFirms: "Toutes les entreprises",
    firm: "Entreprise",
    noUsersFound: "Aucun utilisateur trouvé",
    viewDetails: "Détails",
    fullName: "Nom complet",
    email: "E-mail",
    phone: "Téléphone",
    role: "Rôle",
    status: "Statut",
    suspended: "Suspendu",
    suspendUser: "Suspendre",
    activateUser: "Activer",
    activate: "Activer",
    suspend: "Suspendre",
    activateConfirm: "Cet utilisateur sera activé et pourra se connecter au système.",
    suspendConfirm: "Cet utilisateur sera suspendu et ne pourra pas se connecter au système.",
    userActivated: "Utilisateur activé",
    userSuspended: "Utilisateur suspendu",
    reapprove: "Ré-approuver",
    employee: "Employé",
    firmAdmin: "Admin entreprise",
    confirmApproval: "Confirmer l'approbation",
    approvalSummary: "Résumé de l'approbation",
    rejectionWarning: "Attention",
    rejectionMessage: "Cet utilisateur sera refusé et ne pourra pas se connecter au système.",
    reason: "Raison",
    rejectReasonPlaceholder: "Expliquez la raison du refus...",
    deleteUserWarning: "Cette action ne peut pas être annulée. Toutes les données de l'utilisateur seront supprimées.",
    impersonate: "Se connecter en tant que",
    sendPasswordReset: "Envoyer la réinitialisation du mot de passe",
    sendPasswordResetTitle: "Envoyer un e-mail de réinitialisation du mot de passe",
    passwordResetSent: "Lien de réinitialisation du mot de passe envoyé à {email}",
    sendEmail: "Envoyer l'e-mail",
    setPassword: "Définir le mot de passe",
    setPasswordTitle: "Définir le mot de passe",
    newPassword: "Nouveau mot de passe",
    generatePassword: "Générer aléatoirement",
    setPasswordConfirm: "Enregistrer le mot de passe",
    changeFirm: "Changer d'entreprise",
    newFirm: "Nouvelle entreprise",
    transfer: "Transférer",
    transferSuccess: "Utilisateur transféré avec succès",
    selectDifferentFirm: "Veuillez sélectionner une autre entreprise",
    firmTransferWarning: "Cette action n'affecte pas les soldes de congé de l'utilisateur.",
    changeRole: "Changer de rôle",
    pagePermissions: "Permissions de page",
    allowedFirms: "Entreprises autorisées",
    allowedFirmsDesc: "Laissez vide pour refuser tout accès",
    pageAccess: "Accès aux pages",
    pageAccessDesc: "Laissez vide pour autoriser toutes les pages",
    additionalPermissions: "Permissions supplémentaires",
    canDelete: "Droit de suppression",
    canDeleteDesc: "Peut supprimer des enregistrements",
    canViewFinancial: "Voir les dossiers financiers",
    canViewFinancialDesc: "Peut voir les entrées financières et les sections d'avance",
    canSendNotifications: "Envoyer des notifications",
    canSendNotificationsDesc: "Peut envoyer des notifications aux utilisateurs",
    newRole: "Nouveau rôle",
    changeRoleBtn: "Changer le rôle",
    roleChanged: "Rôle de l'utilisateur modifié",
    selectDifferentRole: "Veuillez sélectionner un rôle différent",
    firmAdminWarning: "L'Admin entreprise peut gérer les utilisateurs et les demandes de congé de son entreprise.",
    export: "Exporter",
    import: "Importer",
    importUsers: "Importer des utilisateurs",
    exportSuccess: "Utilisateurs exportés",
    importSuccess: "Utilisateurs importés",
    importAndUpdate: "Importer et mettre à jour",
    importPreview: "Aperçu",
    importResults: "Résultats",
    created: "Créé",
    updated: "Mis à jour",
    skipped: "Ignoré",
    errors: "Erreurs",
    impersonateAs: "visualisé en tant que",
    returnToAdmin: "retourner au compte",
    deleteLeaveRequestSuccess: "Demande de congé supprimée",
    deleteUserDesc: "Cette action est irréversible. L'utilisateur et toutes les données associées seront supprimés.",
    deleteUserSuccess: "Utilisateur supprimé",
    enterPanel: "Entrer dans le Panneau",
    fullAdminWarning: "L'administrateur complet peut gérer les utilisateurs et les demandes de congé.",
    loginAs: "Se connecter en tant que",
    permissionsSaved: "Permissions enregistrées",
    resetPassword: "Réinitialiser le Mot de Passe",
    sendResetPassword: "Envoyer la Réinitialisation",
    suspendUserDesc: "Les utilisateurs suspendus ne peuvent pas se connecter.",
    unsuspendUser: "Activer l'Utilisateur",
    updatePermissions: "Mettre à jour les Permissions",
    userDetails: "Détails de l'Utilisateur",
    userUnsuspended: "Utilisateur activé",
    confirmRejection: "Êtes-vous sûr de vouloir rejeter ?",
  },
  profile: {
    changePassword: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    passwordChanged: "Mot de passe modifié avec succès",
    passwordMismatch: "Les nouveaux mots de passe ne correspondent pas",
    incorrectPassword: "Mot de passe actuel incorrect",
    accountActive: "Votre compte est actif",
    accountInactive: "Votre compte est inactif",
    accountInfo: "Informations du Compte",
    accountRejected: "Votre compte a été rejeté",
    accountStatus: "Statut du Compte",
    darkMode: "Mode Sombre",
    phone: "Téléphone",
    phoneNumber: "Numéro de Téléphone",
    waitingApproval: "En attente d'approbation",
    company: "Entreprise",
    languageSettings: "Paramètres de Langue",
    lastLogin: "Dernière Connexion",
    memberSince: "Membre Depuis",
    role: "Rôle",
    email: "E-mail",
    fullName: "Nom complet",
    language: "Langue",
    settings: "Paramètres",
    theme: "Thème",
  },
  landing: {
    heroTitle: "Gestion des congés nouvelle génération",
    heroSubtitle: "Gérez, approuvez et suivez facilement les demandes de congé de vos employés dans un environnement numérique.",
    getStarted: "Commencer",
    learnMore: "En savoir plus",
    features: "Fonctionnalités",
    feature1Title: "Suivi facile des congés",
    feature1Desc: "Suivez les congés annuels, maladie et personnels depuis un seul tableau de bord.",
    feature2Title: "Processus d'approbation rapide",
    feature2Desc: "Les managers peuvent approuver ou refuser instantanément les demandes de congé.",
    feature3Title: "Support multi-entreprises",
    feature3Desc: "Gérez plusieurs entreprises depuis une seule plateforme.",
  },
  notifications: {
    title: "Notifications",
    subtitle: "Gérer les paramètres de notification SMS, E-mail et WhatsApp",
    settings: "Paramètres",
    outbox: "Boîte d'envoi",
    enabled: "Activé",
    disabled: "Désactivé",
    channel: "Canal",
    event: "Événement",
    recipient: "Destinataire",
    status: "Statut",
    attempts: "Tentatives",
    message: "Message",
    details: "Détails",
    lastError: "Dernière erreur",
    settingsSaved: "Paramètres de notification enregistrés",
    testSend: "Envoi test",
    testDescription: "Envoyer une notification de test pour ce canal",
    testSent: "Notification de test envoyée",
    retryQueued: "Mis en file d'attente pour réessai",
    send: "Envoyer",
    providerUrl: "URL du fournisseur",
    apiKey: "Clé API",
    sender: "Expéditeur",
    timeout: "Délai d'attente (ms)",
    smtpHost: "Serveur SMTP",
    smtpPort: "Port SMTP",
    smtpUser: "Utilisateur SMTP",
    smtpPass: "Mot de passe SMTP",
    fromAddress: "Adresse d'expédition",
    emailAddress: "Adresse e-mail",
    phoneNumber: "Numéro de téléphone",
    emailProvider: "Fournisseur d'e-mail",
    mandrillApiKey: "Clé API Mandrill",
    fromName: "Nom de l'expéditeur",
    replyTo: "Adresse de réponse",
    smsApiNote: "L'API est appelée avec les paramètres gsm, mesaj, mesajturu",
    defaultMesajTuru: "Type de message par défaut",
    retry: "Réessayer",
    retryWithReset: "Réessayer avec réinitialisation",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette notification ?",
    deleted: "Notification supprimée",
    selectToDelete: "Sélectionnez les notifications à supprimer",
  },
  validation: {
    required: "Ce champ est obligatoire",
    invalidEmail: "Entrez une adresse e-mail valide",
    passwordMin: "Le mot de passe doit comporter au moins 6 caractères",
    passwordMatch: "Les mots de passe ne correspondent pas",
    phoneFormat: "Entrez un numéro de téléphone valide",
  },
  calendar: {
    title: "Calendrier des congés",
    description: "Vue calendrier des congés approuvés",
    monthly: "Mensuel",
    weekly: "Hebdomadaire",
    today: "Aujourd'hui",
    employeesOnLeave: "Employés en congé",
    totalLeaveDays: "Total jours de congé",
    approvedLeaves: "Congés approuvés",
    monday: "Lun",
    tuesday: "Mar",
    wednesday: "Mer",
    thursday: "Jeu",
    friday: "Ven",
    saturday: "Sam",
    sunday: "Dim",
  },
  leaveTypes: {
    title: "Types de congé",
    description: "Gérer les types de congé dans le système",
    add: "Nouveau type de congé",
    total: "Total",
    active: "Actif",
    inactive: "Inactif",
    code: "Code",
    name: "Nom",
    defaultDays: "Jours par défaut",
    defaultLabel: "Par défaut",
    requiresDocument: "Document requis",
    status: "Statut",
    isActive: "Actif",
    createTitle: "Créer un nouveau type de congé",
    createDescription: "Définir un nouveau type de congé pour le système",
    editTitle: "Modifier le type de congé",
    edit: "Modifier",
    deleteTitle: "Supprimer le type de congé",
    created: "Type de congé créé",
    updated: "Type de congé mis à jour",
    deleted: "Type de congé supprimé",
    activated: "Type de congé activé",
    deactivated: "Type de congé désactivé",
    codeAndNameRequired: "Le code et le nom sont obligatoires",
    noData: "Aucun type de congé défini",
    viewUsers: "Utilisateurs",
    usersWithType: "Utilisateurs avec ce type de congé",
    totalBalances: "Total des soldes",
    totalRequests: "Total des demandes",
    noUsersWithType: "Personne n'utilise ce type de congé",
    canSafelyDelete: "Vous pouvez supprimer ce type de congé en toute sécurité",
    balanceRemoved: "Solde supprimé",
    removeBalance: "Supprimer le solde",
    cannotRemoveWithRequests: "Le solde des utilisateurs avec des demandes de congé ne peut pas être supprimé",
    warningRequestsExist: "Des demandes de congé existent pour ce type. Supprimez les soldes avant de supprimer.",
    adminOnly: "Admin uniquement",
    adminOnlyDesc: "Les utilisateurs ne peuvent pas voir ce type dans leurs demandes de congé",
    yes: "Oui",
    no: "Non",
    days: "jours",
    orphanBalance: "Solde orphelin",
    duplicateCheck: "Vérification doublons",
    color: "Couleur",
    onlyUppercaseAndUnderscore: "Uniquement majuscules et underscore",
    daysCountChanged: "Nombre de jours modifié",
  },
  customers: {
    title: "Gestion des Clients",
    newCustomer: "Créer un Nouveau Client",
    name: "Nom du Client",
    nameRequired: "Le nom du client est obligatoire",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    addButton: "Nouveau Client",
    system: "Système",
    custom: "Personnalisé",
    noCustomers: "Aucun client défini pour le moment",
    deleteTitle: "Supprimer le Client",
    deleteMessage: "Êtes-vous sûr de vouloir supprimer {{name}} ?",
    atLeastOneField: "Vous devez sélectionner au moins un champ",
    operationFailed: "Opération échouée",
    cannotDelete: "Impossible de supprimer",
    deleteFailed: "La suppression a échoué",
    errorOccurred: "Une erreur est survenue",
    calculationMethod: "Méthode de Calcul",
    formFields: "Champs du Formulaire",
    fieldsSelected: "champs sélectionnés",
    defaultValue: "Par défaut",
    preview: "Aperçu",
    calculation: "Calcul",
    update: "Mettre à jour",
    create: "Créer",
    example: "Ex",
    defaultsCreated: "Clients par défaut créés",
    namePlaceholder: "Nom du client",
    slugPlaceholder: "slug_client",
    description: "Gérer les champs de formulaire de route par client",
    slug: "Slug (Code Unique)",
    calculationType: "Type de Calcul",
    fields: "Champs",
    created: "Client créé",
    updated: "Client mis à jour",
    deleted: "Client supprimé",
    categoryBase: "Champs de Base",
    categoryIdentity: "Identité / Numéro",
    categoryPersonnel: "Personnel",
    categoryDistance: "Distance",
    categoryPricing: "Tarification",
    categoryTime: "Temps",
    color: "Couleur",
  },
  vehicles: {
    title: "Mes Véhicules",
    detail: "Détail du Véhicule",
    generalInfo: "Informations Générales",
    technicalInfo: "Informations Techniques",
    ownershipSale: "Propriété & Vente",
    notes: "Notes",
    noNotes: "Aucune note",
    documents: "Documents",
    photos: "Photos",
    maintenanceInsurance: "Entretien & Assurance",
    edit: "Modifier",
    save: "Enregistrer",
    cancelEdit: "Annuler",
    uploadDoc: "Télécharger",
    uploadPhoto: "Télécharger Photo",
    dragDropDocs: "Glissez-déposez les fichiers ici",
    dragDropPhotos: "Glissez-déposez les photos ici",
    subtitle: "Gérer les véhicules de l'entreprise",
    sendReminder: "Envoyer un Rappel",
    excelUpload: "Importer Excel",
    newVehicle: "Nouveau Véhicule",
    searchLabel: "Rechercher",
    searchPlaceholder: "Plaque, marque, modèle, entreprise...",
    fuelTypeFilter: "Type de Carburant",
    statusFilter: "Statut",
    all: "Tous",
    ok: "OK",
    warningStatus: "Avertissement",
    criticalStatus: "Critique",
    totalVehicles: "Total Véhicules",
    firmCount: "Nombre d'Entreprises",
    hasWarnings: "Avertissements",
    hasCritical: "Critique",
    brandDistribution: "Répartition par Marque",
    fuelDistribution: "Répartition par Carburant",
    unknownBrand: "Inconnu",
    notSpecified: "Non spécifié",
    noDataFound: "Aucune donnée trouvée",
    vehicleList: "Liste des Véhicules",
    vehicleCount: "véhicules",
    totalLabel: "total",
    hideChart: "Masquer le Graphique",
    showBrandChart: "Graphique des Marques",
    selectedCount: "véhicules sélectionnés",
    deleteSelected: "Supprimer la Sélection",
    noVehicles: "Aucun véhicule trouvé",
    addFirst: "Ajouter le Premier Véhicule",
    editVehicle: "Modifier le Véhicule",
    addVehicle: "Ajouter un Nouveau Véhicule",
    plateRequired: "La plaque d'immatriculation est obligatoire",
    firmRequired: "La sélection de l'entreprise est obligatoire",
    vehicleUpdated: "Véhicule mis à jour",
    vehicleAdded: "Véhicule ajouté",
    vehicleDeleted: "Véhicule supprimé",
    deleteError: "Erreur de suppression",
    importError: "Erreur d'importation",
    notificationFailed: "La notification n'a pas pu être envoyée",
    bulkDeleteError: "Erreur de suppression en masse",
    errorOccurred: "Une erreur est survenue",
    selectFirm: "Sélectionner l'entreprise",
    platePlaceholder: "Ex: 1-ABC-123",
    brandPlaceholder: "Ex: Ford",
    modelPlaceholder: "Ex: Transit",
    yearPlaceholder: "Ex: 2023",
    selectColor: "Sélectionner la couleur",
    vehicleDetailsSection: "Détails du Véhicule",
    chassisPlaceholder: "Numéro de châssis",
    loadPlaceholder: "Ex: 1162 KG",
    fuelSelectLabel: "Type de carburant",
    permitPlaceholder: "Numéro de permis",
    ownershipPlaceholder: "Type de propriété",
    purchasePlaceholder: "Lieu d'achat",
    insuranceCompanyLabel: "Compagnie d'assurance",
    maintenanceTracking: "Suivi Entretien & Assurance",
    insuranceExpiryDate: "Date d'Expiration Assurance",
    inspectionExpiryDate: "Date d'Expiration Contrôle",
    lastMaintenanceDate: "Date du Dernier Entretien",
    nextMaintenanceDate: "Date du Prochain Entretien",
    lastMaintenanceKmLabel: "Dernier Entretien KM",
    nextMaintenanceKmLabel: "Prochain Entretien KM",
    notesLabel: "Notes",
    notesPlaceholder: "Informations supplémentaires...",
    selectOption: "Sélectionner",
    maintenanceKmPlaceholder: "Ex: 50000",
    nextMaintenanceKmPlaceholder: "Ex: 60000",
    ruhsatInVehicle: "Dans le véhicule",
    ruhsatOutVehicle: "Hors du véhicule",
    tableStatus: "Statut",
    tablePlate: "Plaque",
    tableBrandModel: "Marque / Modèle",
    tableYear: "Année",
    tableFuel: "Carburant",
    tableOwnership: "Propriété",
    tableInsurance: "Assurance",
    tableInspection: "Contrôle",
    tableNextMaintenance: "Prochain Entretien",
    tableFirm: "Entreprise",
    documentsTitle: "Documents",
    vehicleDetailTitle: "Détail du Véhicule",
    deleteVehicleTitle: "Supprimer le Véhicule",
    deleteVehicleConfirm: "Êtes-vous sûr de vouloir supprimer le véhicule avec plaque",
    bulkDeleteTitle: "Suppression en Masse",
    bulkDeleteMessage: "véhicules seront supprimés. Cette action est irréversible.",
    deleteCountBtn: "Supprimer Véhicules",
    buildYear: "Année de Construction",
    showSold: "Afficher les vendus",
    resetFilters: "Réinitialiser",
    vehicleLoadError: "Impossible de charger le véhicule",
    saved: "Enregistré",
    saveError: "Erreur de sauvegarde",
    docUploaded: "{{count}} document(s) téléchargé(s)",
    uploadError: "Erreur de téléchargement",
    docDeleted: "Document supprimé",
    updateError: "Erreur de mise à jour",
    photoUploaded: "{{count}} photo(s) téléchargée(s)",
    photoDeleted: "Photo supprimée",
    previewError: "Impossible de charger l'aperçu",
    pdfLoadError: "Impossible de charger le PDF",
    loadingPreview: "Chargement...",
    sold: "VENDU",
    ownershipType: "Location / Propriété",
    plate: "Plaque d'immatriculation",
    brand: "Marque",
    model: "Modèle",
    color: "Couleur",
    firm: "Entreprise",
    chassisNumber: "Numéro de châssis",
    loadCapacity: "Capacité de charge",
    fuelType: "Type de carburant",
    permitNumber: "Numéro de permis",
    sticker: "Vignette",
    insuranceCompany: "Compagnie d'assurance",
    expiryDate: "Date d'expiration",
    lastMaintenance: "Dernier Entretien",
    nextMaintenance: "Prochain Entretien",
    lastMaintenanceKm: "Dernier Entretien KM",
    nextMaintenanceKm: "Prochain Entretien KM",
    purchaseLocation: "Lieu d'achat",
    purchaseDate: "Date d'achat",
    saleDate: "Date de vente",
    keuring: "Contrôle Technique",
    ruhsat: "Certificat d'immatriculation",
    vergunning: "Vergunning",
    sigortaPolicesi: "Police d'assurance",
    muayeneRaporu: "Rapport de contrôle",
    bakimRaporu: "Rapport d'entretien",
  },
  dailyStatus: {
    title: "Statut des employés",
    description: "Suivre les statuts quotidiens des employés",
    today: "Aujourd'hui",
    status: "Statut",
    selectStatus: "Sélectionner le statut",
    legend: "Légende des statuts",
    noUsers: "Aucun utilisateur trouvé",
    updatedBy: "Mis à jour par",
    working: "Travaillé",
    halfDay: "Demi-journée",
    sick: "Malade",
    dop: "Jour de repos",
    onLeave: "En congé",
    paternity: "Congé paternité",
    notSet: "Non défini",
    cancel: "Annuler",
    goToPage: "Voir tous les statuts",
    clickToApplyAll: "Cliquez pour modifier en masse",
    setAllTo: "Définir tout sur {status}",
    clearAllStatuses: "Effacer tous les statuts",
    updatingAll: "Mise à jour de tous les utilisateurs...",
    bulkUpdateTitle: "Modification de statut en masse",
    bulkUpdateConfirm: "Êtes-vous sûr de vouloir définir le statut de tous les employés sur \"{status}\" ?",
    usersWillBeUpdated: "utilisateurs seront mis à jour",
    filteredUsers: "Filtre de recherche appliqué",
    applyToAll: "Appliquer à tous",
    bulkUpdateSuccess: "{count} utilisateurs mis à jour",
    bulkUpdateError: "{count} utilisateurs n'ont pas pu être mis à jour",
    allUsersAlreadyHaveStatus: "Tous les utilisateurs ont déjà ce statut",
    pendingChanges: "modifications",
    statusUpdated: "Statut mis à jour",
    employeesUpdated: "employés mis à jour",
    noChanges: "Aucune modification",
    changesSaved: "Modifications enregistrées",
    selectedEmployees: "employés sélectionnés",
    allEmployees: "tous les employés",
    bulkWarning: "Le statut sera mis à jour pour tous les employés",
    daySummary: "Résumé du jour",
    showEmployees: "Afficher les employés",
    hideEmployees: "Masquer les employés",
    quickEditMode: "Mode marquage rapide",
    quickEditActive: "sélectionné - Cliquez sur les cellules pour marquer rapidement",
    clickAgainToClear: "Cliquez à nouveau pour effacer",
    clickStatusToActivate: "Sélectionnez un statut pour commencer le marquage rapide",
    tapCellToApply: "Appuyez sur la cellule",
    clickCellToApply: "Cliquez sur une cellule pour appliquer le statut • Cliquez à nouveau pour effacer",
    switchTo: "Changer:",
    exitQuickEdit: "Quitter",
    overwriteConfirmTitle: "Le Statut Existant Sera Modifié",
    overwriteConfirmDesc: "Cette cellule a déjà un statut. Voulez-vous le modifier ?",
    currentStatus: "Statut Actuel",
    newStatus: "Nouveau Statut",
    confirmOverwrite: "Oui, Modifier",
    allUsersHaveStatus: "Tous les utilisateurs ont déjà un statut",
    skippedExisting: "statut existant ignoré",
    willBeUpdated: "Sera Mis à Jour",
    willBeSkipped: "Sera Ignoré",
    existingStatusesProtected: "Les statuts existants seront préservés",
    cannotEditPastDates: "Vous ne pouvez pas modifier les dates passées",
    syncLeaves: "Synchroniser les Congés",
    syncLeavesTitle: "Synchronisation des Congés",
    syncLeavesDesc: "Synchroniser les congés approuvés avec le statut quotidien",
    syncEmployees: "employés avec",
    syncMissingDays: "jours manquants trouvés",
    missingDayCount: "jours manquants",
    syncUser: "Synchroniser",
    syncAll: "Tout Synchroniser",
    allSynced: "Tous les congés sont synchronisés !",
    noMissingDays: "Aucun jour manquant trouvé.",
    day: "jours",
    confirmPastEdit: "Oui, Modifier",
    externalFirm: "Entreprise Externe",
    pastDateConfirmMessage: "Vous êtes sur le point de modifier le statut de l'employé à une date passée. Continuer ?",
    pastDateConfirmTitle: "Modifier une date passée ?",
    showOnlyWorking: "Uniquement en service",
    todayShort: "Aujourd'hui",
    noPastEditPermission: "Pas de permission pour modifier les dates passées",
    pastDateConfirmNote: "Cela n'affecte pas les dates verrouillées",
    pastDateWarning: "Modification d'une date passée",
    selectExternalFirm: "Sélectionnez une entreprise externe",
    weekViewLabel: "Semaine",
    willShowAs: "sera affiché comme",
  },
  leaveRequestsAdmin: {
    addForUser: "Ajouter un congé pour l'utilisateur",
    addForUserDesc: "Créer une demande de congé au nom d'un utilisateur",
    autoApprove: "Approuver automatiquement",
    autoApproveDesc: "La demande de congé est immédiatement approuvée et déduite du solde",
    createAndApprove: "Créer et approuver",
    createdAndApproved: "Demande de congé créée et approuvée",
    created: "Demande de congé créée",
    fillRequired: "Veuillez remplir tous les champs obligatoires",
    selectUser: "Sélectionner l'utilisateur",
    create: "Créer",
  },
  myFinance: {
    title: "Mes Finances",
    subtitle: "Avances, POT, indemnité de recharge et autres relevés",
    hiddenTitle: "Données financières actuellement masquées",
    hiddenDesc: "L'administrateur de votre entreprise a désactivé la visibilité des données financières des employés. Veuillez contacter votre administrateur.",
    savePdf: "Enregistrer en PDF",
  },
  workStats: {
    myStatistics: "Mon statut de travail",
    myStatisticsDesc: "Résumé du statut de travail annuel",
    adminStatistics: "Statistiques de travail",
    employeeStatistics: "Statistiques des employés",
    adminStatisticsDesc: "Statistiques de statut de tous les employés",
    monthlyBreakdown: "Répartition mensuelle",
    statusDistribution: "Répartition des statuts",
    calendarView: "Vue calendrier",
    employeeBreakdown: "Répartition par employé",
    yearSummary: "Résumé annuel",
    periodSummary: "Résumé de la période",
    totalRecords: "total de",
    daysRecorded: "jours enregistrés",
    periodTotal: "total de la période",
    recordsFound: "enregistrements trouvés",
    employeesTracked: "employés suivis",
    quickRange: "Sélection rapide",
    today: "Aujourd'hui",
    yesterday: "Hier",
    thisWeek: "Cette semaine",
    lastWeek: "Semaine dernière",
    thisMonth: "Ce mois",
    thisQuarter: "Ce trimestre",
    thisYear: "Cette année",
    dateRange: "Plage de dates",
    year: "Année",
    startDate: "Date de début",
    endDate: "Date de fin",
    exportExcel: "Télécharger Excel",
    exportSuccess: "Fichier Excel téléchargé",
    externalFirm: "Entreprise Externe",
    lastMonth: "Mois Dernier",
  },
  employeeProfile: {
    title: "Profils des Employés",
    myProfile: "Mon Profil",
    personalInfo: "Informations Personnelles",
    documents: "Documents",
    history: "Congés & Historique",
    finance: "Finance & Statistiques",
    profileCompletion: "Complétion du Profil",
    complete: "Complet",
    incomplete: "Incomplet",
    saveProfile: "Enregistrer",
    uploadDocument: "Télécharger Document",
    addFinanceEntry: "Ajouter une Entrée",
    type: "Type",
    myDocuments: "Mes Documents",
    employeeDocuments: "Documents de l'Employé",
    documentsOf: "Documents de",
    firstName: "Prénom",
    lastName: "Nom",
    birthDate: "Date de Naissance",
    birthPlace: "Lieu de Naissance",
    nationality: "Nationalité",
    nationalId: "Numéro National",
    maritalStatus: "État Civil",
    bloodType: "Groupe Sanguin",
    idExpiryDate: "Date d'Expiration de la Carte d'Identité",
    licenseExpiryDate: "Date d'Expiration du Permis de Conduire",
    ocrHint: "Rempli automatiquement lors du téléchargement",
    ocrProcessing: "Numérisation du document, extraction des dates...",
    ocrExpiryFound: "Date d'expiration trouvée",
    ocrDatesFound: "Dates trouvées",
    ocrNoDateFound: "Aucune date trouvée dans le document. Veuillez entrer manuellement.",
    ocrError: "Erreur de numérisation OCR",
    employmentDates: "Dates d'Emploi",
    employmentStartDate: "Date d'Entrée",
    employmentEndDate: "Date de Départ",
    employmentDatesUpdated: "Dates d'emploi mises à jour",
    employmentDatesError: "Échec de la mise à jour des dates",
    single: "Célibataire",
    married: "Marié(e)",
    divorced: "Divorcé(e)",
    widowed: "Veuf/Veuve",
    cohabiting: "Cohabitant légal",
    addressInfo: "Adresse",
    street: "Rue",
    houseNumber: "Numéro",
    postalCode: "Code Postal",
    city: "Ville",
    country: "Pays",
    contactBankInfo: "Contact & Coordonnées Bancaires",
    phone: "Téléphone",
    emailAddress: "Adresse E-mail",
    bankAccount: "Compte Bancaire (IBAN)",
    fiscalInfo: "Situation Fiscale Familiale",
    fiscalInfoDesc: "Indiquez les personnes à charge fiscalement",
    childrenDependent: "Enfants à charge",
    numberOfChildren: "Nombre d'enfants",
    spouseDependent: "Conjoint(e) à charge",
    otherDependents: "Autres personnes à charge",
    numberOfOtherDependents: "Nombre de personnes",
    importantDocuments: "Documents Importants",
    importantDocumentsDesc: "Vos documents d'identité, attestation de conducteur et permis de conduire",
    frontSide: "Recto",
    backSide: "Verso",
    showFrontSide: "Afficher le recto",
    showBackSide: "Afficher le verso",
    noDocuments: "Aucun document disponible",
    noDocumentsDesc: "Votre administrateur peut vous attribuer des documents",
    firstUpload: "Télécharger le premier document",
    documentType: "Type de Document",
    documentNumber: "Numéro du Document",
    issueDate: "Date d'Émission",
    expiryDate: "Date d'Expiration",
    notes: "Notes",
    download: "Télécharger",
    selectFile: "Sélectionner un fichier",
    dragDrop: "Cliquez pour télécharger ou glisser-déposer",
    fileTypes: "PDF, JPG, PNG, DOC (max 10Mo)",
    uploadedBy: "Téléchargé par",
    date: "Date",
    idCard: "Carte d'Identité",
    passport: "Passeport",
    driverLicense: "Permis de Conduire",
    residencePermit: "Titre de Séjour",
    workContract: "Contrat de Travail",
    diploma: "Diplôme/Certificat",
    medicalCert: "Certificat Médical",
    bankDetails: "Coordonnées Bancaires",
    taxForm: "Fiche Fiscale",
    other: "Autre",
    approved: "Approuvé",
    pending: "En attente",
    leaveDays: "Jours de Congé",
    workDays: "Jours Travaillés",
    recentLeaves: "Demandes de Congé Récentes",
    noLeaves: "Aucune demande de congé",
    totalDebt: "Dette Totale",
    totalPaid: "Total Payé",
    bonus: "Prime",
    netBalance: "Solde Net",
    transactionHistory: "Historique des Transactions",
    noTransactions: "Aucune transaction",
    financeHidden: "Informations financières masquées par l'administrateur",
    advance: "Avance",
    debt: "Dette",
    payment: "Paiement",
    deduction: "Déduction",
    bonusType: "Prime",
    potPlus: "POT+ (Crédit)",
    potMinus: "POT- (Débit)",
    laadvergoeding: "Frais de Recharge (Électrique)",
    leasing: "Leasing",
    otherType: "Autre",
    addNew: "Ajouter",
    amount: "Montant",
    description: "Description",
    deleteRecord: "Supprimer l'Enregistrement",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer cet enregistrement?",
    employeesFound: "employés trouvés",
    searchPlaceholder: "Rechercher par nom ou e-mail...",
    allProfiles: "Tous les Profils",
    completeProfiles: "Complets",
    incompleteProfiles: "Incomplets",
    allFirms: "Toutes les Entreprises",
    avgCompletion: "Complétion Moy.",
    noEmployees: "Aucun employé trouvé",
    exportCsv: "Exporter CSV",
    employee: "Employé",
    contact: "Contact",
    profile: "Profil",
    profileSaved: "Profil enregistré",
    profileSaveError: "Échec de l'enregistrement",
    documentUploaded: "Document téléchargé",
    documentsUploaded: "documents téléchargés",
    documentUploadError: "Échec du téléchargement",
    dragDropMultiple: "Glissez et déposez les fichiers ici",
    orClickToSelect: "ou cliquez pour sélectionner",
    clickToAddMore: "Cliquez ou glissez pour ajouter plus de fichiers",
    filesSelected: "fichiers sélectionnés",
    invalidFileType: "Certains fichiers ont un format non supporté",
    forUpload: "télécharger document pour",
    dropFilesHere: "Déposez les fichiers ici",
    filesWillBeUploaded: "Les fichiers seront téléchargés",
    dragDropHint: "Astuce: Vous pouvez télécharger rapidement des fichiers en les faisant glisser dans cette zone",
    deleteDocumentTitle: "Supprimer le Document",
    deleteDocumentConfirm: "Êtes-vous sûr de vouloir supprimer ce document ?",
    deleteDocumentWarning: "Cette action ne peut pas être annulée.",
    documentDeleted: "Document supprimé",
    documentDeleteError: "Échec de la suppression",
    editDocument: "Modifier le Document",
    documentUpdated: "Document mis à jour",
    documentUpdateError: "Échec de la mise à jour du document",
    categoryHint: "Sélectionnez la catégorie du document",
    currentCategory: "Catégorie Actuelle",
    documentSideUploaded: "téléchargé",
    unsupportedFileFormat: "Format de fichier non supporté. Veuillez télécharger JPG, PNG, PDF ou HEIC.",
    downloadError: "Erreur de téléchargement",
    loadError: "Erreur de chargement",
    category: "Catégorie",
    personal: "Personnel",
    company: "Entreprise",
    back: "Retour",
    uploadBtn: "Télécharger",
    cancelBtn: "Annuler",
    deleteBtn: "Supprimer",
    completeProfileTitle: "Complétez votre Profil",
    completeProfileDesc: "Veuillez remplir vos informations de profil avant de continuer.",
    goToProfile: "Aller au Profil",
    selectFileAndType: "Sélectionnez un fichier et un type de document",
    requiredFields: "Remplissez les champs obligatoires",
    expiringDocuments: "Documents Expirants",
    expiringDocumentsDesc: "Employés avec des documents bientôt expirés",
    expired: "Expiré",
    noExpiringDocuments: "Aucun document expirant",
    addNote: "Ajouter une Note",
    addNoteDesc: "Ajoutez une note privée sur cet employé (visible uniquement par les administrateurs)",
    notePlaceholder: "Écrivez votre note ici...",
    notesList: "Notes",
    noNotes: "Pas encore de notes",
    packagesTab: "Colis",
    today: "Aujourd'hui",
    yesterday: "Hier",
    thisWeek: "Cette Semaine",
    thisMonth: "Ce Mois",
    thisYear: "Cette Année",
    allRegions: "Toutes les Régions",
    totalPackages: "Total Colis",
    workedDays: "Jours Travaillés",
    dailyAvg: "Moy. Quotidienne",
    region: "Région",
    totalAmount: "Montant Total",
    dailyPackageDist: "Distribution Quotidienne des Colis",
    last30DaysPackages: "Nombre de colis des 30 derniers jours",
    regionDist: "Distribution par Région",
    regionDistDesc: "Distribution des colis par région",
    packageCount: "pièces",
    packageLabel: "Colis",
    amountLabel: "Montant",
    loonbriefsTab: "Fiches de Paie",
    loonbriefsTitle: "Fiches de Paie",
    loonbriefsDesc: "documents de paie téléchargés pour",
    uploadedOn: "téléchargé le",
    viewBtn: "Voir",
    downloadBtn: "Télécharger",
    noLoonbriefs: "Pas encore de fiches de paie",
    noLoonbriefsDesc: "Vous pouvez télécharger des fiches de paie depuis la page de téléchargement",
    allYears: "Toutes les Années",
    selectMonth: "Sélectionner le Mois",
    period: "Période",
    viewProfile: "Voir le profil",
    applyOcrData: "Appliquer les données",
    ocrAllDatesHint: "Autres dates trouvées (cliquez pour sélectionner) :",
    ocrResultsEditableDesc: "Les dates trouvées par l'OCR sont affichées ci-dessous. Vous pouvez les corriger ou les saisir manuellement si elles sont incorrectes.",
    documentEditor: {
      dragDropTitle: "Glissez et déposez le document",
      supportedFormats: "JPG, PNG, WEBP, PDF pris en charge",
      selectFile: "Sélectionner un Fichier",
      pasteFromClipboard: "Coller depuis le Presse-papiers",
      pasteHint: "Appuyez sur Ctrl+V pour coller directement depuis le presse-papiers",
      rotateLeft: "Pivoter à Gauche",
      rotateRight: "Pivoter à Droite",
      flipHorizontal: "Retourner Horizontalement",
      flipVertical: "Retourner Verticalement",
      reset: "Réinitialiser",
      changeImage: "Sélectionner un Autre Fichier",
      save: "Enregistrer",
      saveAndUpload: "Enregistrer & Télécharger",
      cancel: "Annuler",
      crop: "Recadrer",
      applyChanges: "Appliquer les Modifications",
      deleteDocument: "Supprimer le Document",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce document ?",
      deleteSuccess: "Document supprimé",
      processing: "Traitement...",
      zoom: "Zoom",
      edit: "Modifier",
      editing: "Modification en cours",
      readyToUpload: "Prêt à Télécharger",
      rotate: "Pivoter",
      zoomIn: "Zoom Avant",
      zoomOut: "Zoom Arrière",
      cropAndUpload: "Recadrer et télécharger",
      skipEdit: "Ignorer l'édition",
    },
    addAliasPlaceholder: "Ajouter un nouvel alias...",
    aliases: "Alias / Noms secondaires",
    aliasesDescription: "Utilisé pour la correspondance PDF de la paie. Ex : GEMALMAZ H.",
    aliasesSaved: "Alias enregistrés",
    aliasesTab: "Alias",
    financeTab: "Finances",
    financeTitle: "Registres Financiers",
    manualEntry: "Saisie Manuelle",
    noAliases: "Aucun alias défini",
    noFinanceRecords: "Aucun registre financier",
    ocrDetectedDates: "Dates Détectées par OCR",
    ocrNoResults: "Aucune date détectée",
    removeAlias: "Supprimer l'alias",
    saveAliases: "Enregistrer les Alias",
    showAdvancedSection: "Afficher Avancé",
    totalAdvance: "Total des Avances",
    totalRecords: "Total des Enregistrements",
    applyDates: "Appliquer les Dates",
    approvedDates: "Dates Approuvées",
    changePhoto: "Changer la Photo",
    clickForDetails: "Cliquez pour les détails",
    cropAndEdit: "Recadrer et Modifier",
    daysRemaining: "Jours restants",
    details: "Détails",
    driverLicenseDesc: "Document du permis de conduire",
    identityCard: "Carte d'Identité",
    identityCardDesc: "Document de carte d'identité",
    noPackages: "Aucun forfait",
    noPackagesDesc: "Aucun forfait défini",
    noPayslips: "Aucune fiche de paie",
    noPayslipsDesc: "Aucune fiche de paie téléchargée",
    noPotEntries: "Aucune entrée de feuille de temps",
    notUploaded: "Non téléchargé",
    ocrResults: "Résultats OCR",
    ocrResultsDesc: "Dates trouvées dans le document",
    openInNewTab: "Ouvrir dans un nouvel onglet",
    otherDocuments: "Autres Documents",
    packagesDesc: "Informations sur les forfaits",
    passportDesc: "Document de passeport",
    payslipsDesc: "Documents de fiche de paie",
    photoUploadError: "Échec du téléchargement de la photo",
    photoUploaded: "Photo téléchargée",
    uploadCover: "Télécharger Photo de Couverture",
    coverUploaded: "Photo de couverture téléchargée",
    coverUploadError: "Échec du téléchargement de la couverture",
    addJobTitle: "+ Ajouter rôle / titre",
    jobTitlePlaceholder: "Rôle / titre (ex. Super Admin)",
    addBio: "+ Ajouter une courte bio",
    bioPlaceholder: "Courte bio (max 280 car.)",
    preview: "Aperçu",
    profilePhoto: "Photo de Profil",
    upload: "Télécharger",
    uploadPhoto: "Télécharger la Photo",
    uploaded: "Téléchargé",
  },
  documents: {
    myDocuments: "Mes Documents",
    myDocumentsDesc: "Contrats d'entreprise et documents personnels",
    management: "Gestion des Documents",
    managementDesc: "Gérez les documents de l'entreprise et les dossiers des employés",
    searchPlaceholder: "Rechercher des fichiers...",
    all: "Tout",
    companyDocs: "Documents d'entreprise",
    personalDocs: "Documents Personnels",
    noDocuments: "Aucun fichier",
    noDocumentsDesc: "Aucun fichier ne vous est attribué",
    noDocumentsAdminDesc: "Téléchargez des fichiers pour vos employés",
    company: "Entreprise",
    personal: "Personnel",
    preview: "Aperçu",
    download: "Télécharger",
    fetchError: "Échec du chargement des fichiers",
    downloadSuccess: "Téléchargement en cours",
    downloadError: "Échec du téléchargement",
    previewError: "Échec de l'aperçu",
    uploadError: "Échec du téléchargement",
    updateSuccess: "Fichier mis à jour",
    updateError: "Échec de la mise à jour",
    deleteSuccess: "Fichier supprimé",
    deleteError: "Échec de la suppression",
    deleteConfirm: "Supprimer le Fichier",
    upload: "Télécharger un Fichier",
    uploadFiles: "Télécharger des Fichiers",
    uploadDesc: "Organisez les fichiers et attribuez-les aux employés",
    uploadFirst: "Télécharger le Premier Fichier",
    files: "Fichiers",
    fileName: "Nom du Fichier",
    firm: "Entreprise",
    category: "Catégorie",
    assignedTo: "Attribué À",
    assignTo: "Attribuer À",
    assignToAll: "Attribuer à tous les employés",
    searchUsers: "Rechercher un employé...",
    size: "Taille",
    uploadedAt: "Téléchargé",
    editDocument: "Modifier le Fichier",
    invalidFileType: "Certains fichiers ont un format non pris en charge",
    targetFirm: "Entreprise Cible",
    allCompanies: "Toutes les Entreprises (Global)",
    globalDocNote: "Le document global sera visible par tous les employés",
    pdfLoadError: "Échec du chargement du PDF",
    pdfCorruptOrInvalid: "Le fichier peut être corrompu ou un PDF invalide",
    downloadInstead: "Télécharger le Fichier",
    previewNotSupported: "Aperçu non disponible pour ce type de fichier",
    noPreview: "Aperçu non disponible",
    showing: "Affichage",
    of: "sur",
    items: "éléments",
    perPage: "Par page",
    originalName: "Original",
    filterByFirm: "Filtrer par entreprise",
    uploadSuccess: "Fichier téléchargé",
    allDocuments: "Tous les documents",
    assignedDocuments: "Documents assignés",
    assignedToMe: "Assignés à moi",
    companyDocuments: "Documents de l'entreprise",
    dateRange: "Plage de dates",
    deleteMessage: "Ce document sera supprimé définitivement.",
    documentName: "Nom du document",
    documentType: "Type de document",
    dragDrop: "Glissez-déposez les fichiers ici ou cliquez pour sélectionner",
    employee: "Employé",
    fileSize: "Taille du fichier",
    fileUploaded: "Fichier téléchargé",
    filterByType: "Filtrer par type",
    firmDocuments: "Documents de l'entreprise",
    firmDocumentsDesc: "Documents partagés avec toute l'entreprise",
    noResults: "Aucun document trouvé",
    or: "ou",
    private: "Privé",
    public: "Public",
    selectEmployee: "Sélectionner un employé",
    selectFile: "Sélectionner un fichier",
    totalDocuments: "Total des documents",
    uploadDate: "Date de téléchargement",
    uploadDocument: "Télécharger un document",
    uploadDocumentDesc: "Télécharger un nouveau document",
    uploadedBy: "Téléchargé par",
    visibility: "Visibilité",
    visibleToEmployee: "Visible par l'employé",
  },
  employeeTracking: {
    title: "Suivi des Employés",
    description: "Suivez le statut quotidien des employés",
    filter: "Filtre",
    searchEmployee: "Rechercher un employé...",
    noResults: "Aucun résultat trouvé",
    globalSearch: "Rechercher employé ou plaque...",
    clearFilter: "Effacer le Filtre",
    employee: "Employé",
    employees: "Employés",
    all: "Tous",
    selectFirm: "Sélectionner une entreprise",
    daySummary: "Résumé du Jour",
    totalWorking: "Total Travaillé",
    totalLeave: "Total Congés",
    totalSick: "Total Malade",
    totalDop: "Total DOP",
    noEmployeeFound: "Aucun employé actif trouvé",
    noFilterMatch: "Aucun employé ne correspond aux critères de filtre",
    firmsLoadError: "Échec du chargement des entreprises",
    dataLoadError: "Échec du chargement des données",
    status: {
      working: "Travaillé",
      halfDay: "Demi-journée",
      sick: "Malade",
      dop: "DOP",
      onLeave: "En Congé",
      holiday: "Jour Férié",
      halfSick: "Demi Malade",
      saturday: "Samedi",
      paternity: "Congé Paternité",
      unknown: "Inconnu",
    },
    months: {
      january: "Janvier",
      february: "Février",
      march: "Mars",
      april: "Avril",
      may: "Mai",
      june: "Juin",
      july: "Juillet",
      august: "Août",
      september: "Septembre",
      october: "Octobre",
      november: "Novembre",
      december: "Décembre",
    },
    days: {
      sun: "Dim",
      mon: "Lun",
      tue: "Mar",
      wed: "Mer",
      thu: "Jeu",
      fri: "Ven",
      sat: "Sam",
    },
  },
  routes: {
    title: "Routes / Tours",
    description: "Gérer les données quotidiennes des routes et tours",
    allRoutes: "Liste des Routes",
    newRoute: "Nouvelle Route",
    editRoute: "Modifier Route",
    addRoute: "Ajouter Nouvelle Route",
    importExcel: "Importer Excel",
    exportExcel: "Exporter Excel",
    recalculate: "Recalculer",
    recalculateTitle: "Recalculer Toutes les Tournées",
    recalculateBody: "Toutes les heures de travail et montants totaux des enregistrements existants seront recalculés avec les règles de calcul actuelles. Les anciens enregistrements incorrects (ex: taux horaire=0) seront corrigés. Cette action est irréversible.",
    customer: "Client",
    customers: "Clients",
    multiSelect: "Sélection multiple",
    firm: "Entreprise",
    allFirms: "Toutes les Entreprises",
    month: "Mois",
    allMonths: "Tous les Mois",
    search: "Rechercher",
    searchPlaceholder: "Chauffeur, plaque...",
    date: "Date",
    licensePlate: "Plaque d'Immatriculation",
    driver: "Chauffeur",
    copilot: "Copilote",
    routeNumber: "N° Route",
    routeType: "Type de Route",
    ritNumber: "N° Rit",
    rit: "Rit",
    tour: "Tour",
    routeRitTour: "Route/Rit/Tour",
    place: "Lieu",
    startTime: "Début",
    endTime: "Fin",
    breakTime: "Pause",
    workHours: "Heures de Travail",
    hourlyRate: "Taux Horaire",
    startCost: "Coût de Départ",
    workCost: "Coût de Travail",
    totalCost: "Total",
    kmStart: "KM Début",
    kmEnd: "KM Fin",
    kmTotal: "KM Total",
    km: "KM",
    time: "Heure",
    price: "Prix",
    total: "Total",
    actions: "Actions",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    selectAll: "Tout Sélectionner",
    deleteSelected: "Supprimer Sélectionnés",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet enregistrement?",
    confirmBulkDelete: "Êtes-vous sûr de vouloir supprimer {count} enregistrements sélectionnés?",
    noRecords: "Aucun enregistrement trouvé pour ce mois",
    addFirstRecord: "Ajouter le Premier Enregistrement",
    records: "enregistrements",
    deleteRecords: "Supprimer Enregistrements",
    selectRow: "Sélectionner la ligne",
    selectAllOnPage: "Sélectionner tout sur cette page",
    perPage: "Par page",
    firstPage: "Première page",
    previousPage: "Page précédente",
    nextPage: "Page suivante",
    lastPage: "Dernière page",
    editAllFields: "Modifier tous les champs",
    copyWithToday: "Copier (avec la date d'aujourd'hui)",
    copyRecords: "copier",
    exportFiltered: "Exporter les données filtrées",
    viewAttachments: "Pièces jointes",
    summary: {
      totalRecords: "Total Enregistrements",
      totalHours: "Total Heures",
      totalKm: "Total KM",
      totalAmount: "Montant Total",
      perRecord: "moy. par enregistrement",
    },
    import: {
      title: "Importer depuis Excel",
      multiSheetSupport: "Support Multi-Feuilles",
      customerType: "Type de Client",
      pleaseSelectCustomer: "Veuillez sélectionner un type de client",
      columnMapping: "Les colonnes Excel seront mappées selon le type de client sélectionné",
      firmLabel: "Entreprise:",
      selectFirm: "Sélectionner entreprise",
      required: "Obligatoire",
      dragDropFile: "Glissez-déposez le fichier ou cliquez",
      dropFileHere: "Déposez le fichier ici...",
      fileFormats: "CSV ou Excel (.xlsx) • Plusieurs feuilles supportées",
      selectFile: "Sélectionner Fichier",
      unsupportedFormat: "Format de fichier non supporté. Veuillez sélectionner un fichier .xlsx, .xls ou .csv.",
      excelLoaded: "Excel chargé",
      sheetsCount: "feuilles",
      totalRows: "lignes au total",
      rowsRead: "lignes lues",
      fileReadError: "Échec de la lecture du fichier",
      sheetSelection: "Sélection de Feuille",
      sheetsSelected: "feuilles sélectionnées",
      rows: "lignes",
      selectDeselectAll: "Sélectionner / Désélectionner Tout",
      noData: "Aucune donnée",
      preview: "Aperçu",
      toImport: "À Importer",
      sheet: "feuille",
      selectedSheets: "Feuilles sélectionnées",
      moverColumns: "Colonnes Excel Mover:",
      fedexColumns: "Colonnes Excel FedEx:",
      expressColumns: "Colonnes Excel Express:",
      getaxColumns: "Colonnes Excel GeTax:",
      optionalFields: "Optionnel",
      defaultRate: "par défaut",
      startCost: "Start kost",
      notes: "Opmerkingen",
      selectCustomerType: "Sélectionner Type Client",
      importRecords: "Importer Enregistrements",
      importSheets: "Feuille",
      noDataToImport: "Aucune donnée à importer",
      andMore: "et",
      moreRows: "lignes supplémentaires (sur cette feuille)",
      duplicateWarning: "enregistrements en double ignorés",
      selectSheet: "Sélectionner Feuille",
      selectCustomer: "Sélectionner Type Client",
      customerRequired: "Veuillez d'abord sélectionner le type de client",
      dragDrop: "Glisser-déposer ou cliquer",
      rowsFound: "lignes trouvées",
      import: "Importer",
      importing: "Importation...",
      success: "enregistrements importés avec succès",
      duplicatesSkipped: "enregistrements en double ignorés",
      error: "Erreur d'importation",
      moreRecords: "enregistrements supplémentaires",
    },
    form: {
      selectDate: "Sélectionner date",
      selectDriver: "Sélectionner chauffeur",
      selectCopilot: "Sélectionner copilote",
      selectVehicle: "Sélectionner véhicule",
      manualEntry: "Saisie manuelle",
      searchEmployee: "Rechercher employé...",
      noEmployeeFound: "Aucun employé trouvé",
      calculation: "Calcul",
      searchDriver: "Rechercher chauffeur...",
      searchCopilot: "Rechercher copilote...",
      driverNotFound: "Chauffeur non trouvé",
      loading: "Chargement...",
      customerRequired: "Client *",
      customerCannotChange: "Le client ne peut pas être modifié pendant l'édition",
      firmRequired: "Entreprise *",
      selectFirm: "Sélectionner entreprise",
      dateRequired: "Date *",
      routeNumberLabel: "Numéro de Route",
      routeNumberPlaceholder: "Ex.: 741",
      tourTypeRequired: "Type de Tour *",
      selectTour: "Sélectionner tour",
      tourTypePlaceholder: "Entrer le type de tour...",
      ritRequired: "Rit *",
      selectRit: "Sélectionner rit",
      enterRit: "Entrer rit...",
      list: "Liste",
      vehiclePlateRequired: "Plaque d'Immatriculation *",
      searchPlate: "Rechercher et sélectionner plaque...",
      selectFirmFirst: "Sélectionner d'abord l'entreprise",
      searchPlatePlaceholder: "Rechercher plaque...",
      vehicleNotFound: "Véhicule non trouvé",
      orManualEntry: "ou saisir manuellement:",
      enterPlate: "Entrer la plaque...",
      driverRequired: "Chauffeur *",
      searchAndSelectDriver: "Rechercher et sélectionner chauffeur...",
      enterDriverName: "Nom du chauffeur",
      allDrivers: "Tous les Chauffeurs",
      firmDrivers: "Chauffeurs de l'entreprise",
      copilotLabel: "Copilote",
      searchAndSelectCopilot: "Rechercher et sélectionner copilote...",
      enterCopilotName: "Nom du copilote",
      kmStartLabel: "KM Début",
      kmStartPlaceholder: "Ex.: 40447",
      kmEndLabel: "KM Fin",
      kmEndPlaceholder: "Ex.: 40531",
      hourlyRateLabel: "Taux Horaire (€)",
      startCostLabel: "Coût de Départ (€)",
      startTimeLabel: "Heure de Début",
      endTimeLabel: "Heure de Fin",
      breakTimeLabel: "Temps de Pause",
      calculatedValues: "Valeurs Calculées",
      totalKm: "Total KM:",
      workDuration: "Durée de Travail:",
      totalAmount: "Montant Total:",
      notesLabel: "Notes",
      notesPlaceholder: "Notes supplémentaires...",
    },
    messages: {
      saveSuccess: "Route enregistrée",
      saveError: "Échec de l'enregistrement de la route",
      deleteSuccess: "Route supprimée",
      deleteError: "Échec de la suppression de la route",
      bulkDeleteSuccess: "enregistrements supprimés",
      bulkDeleteError: "Échec de la suppression des enregistrements",
      loadError: "Échec du chargement des données",
      exportSuccess: "enregistrements exportés",
      exportError: "Erreur d'exportation",
      recalculated: "enregistrements recalculés",
      alreadyCorrect: "déjà corrects",
      recalculateError: "Erreur de recalcul",
      routeUpdated: "Route mise à jour",
      routeAdded: "Route ajoutée",
      routeDeleted: "Route supprimée",
      routeCopied: "Route copiée",
      copyFailed: "Échec de la copie",
      errorOccurred: "Une erreur s'est produite",
      updated: "Mis à jour",
      updateError: "Erreur de mise à jour",
      driverUpdated: "Chauffeur mis à jour",
      selectRecordsToDelete: "Veuillez sélectionner les enregistrements à supprimer",
      bulkDeleteConfirm: "{count} enregistrements seront supprimés. Êtes-vous sûr?",
      bulkDeleteError2: "Erreur de suppression en masse",
    },
    table: {
      clickToEdit: "Double-cliquez sur la cellule pour modifier",
      hoverIcon: "icône crayon apparaît au survol",
      doubleClickStart: "Double-cliquez: Heure de début",
      doubleClickEnd: "Double-cliquez: Heure de fin",
    },
  },
  routeReports: {
    title: "Rapports Routes",
    description: "Voir les statistiques des routes et tours",
    customer: "Client",
    firm: "Entreprise",
    allFirms: "Toutes les Entreprises",
    dateRange: "Plage de Dates",
    startDate: "Date de Début",
    endDate: "Date de Fin",
    filter: "Filtrer",
    summary: "Statistiques Résumées",
    totalRoutes: "Total Routes",
    totalHours: "Total Heures",
    totalKm: "Total KM",
    totalAmount: "Montant Total",
    avgPerDay: "Moyenne Quotidienne",
    avgPerRoute: "Moyenne par Route",
    monthlyTrend: "Tendance Mensuelle",
    weeklyTrend: "Tendance Hebdomadaire",
    driverStats: "Statistiques Chauffeur",
    vehicleStats: "Statistiques Véhicule",
    noData: "Aucune donnée trouvée pour les critères sélectionnés",
    loadError: "Échec du chargement des rapports",
    records: "Enregistrements",
    currentPeriod: "Période Actuelle",
    previousPeriod: "Période Précédente",
    last6MonthsLabel: "6 Derniers Mois",
    previous6MonthsLabel: "6 Mois Précédents",
    last12MonthsLabel: "12 Derniers Mois",
    previous12MonthsLabel: "12 Mois Précédents",
    driverDetails: "Détails Chauffeur",
    routeCount: "Nombre de Routes",
    totalIncome: "Revenu Total",
    periodComparison: "Comparaison de Période",
    last6Months: "6 Derniers Mois vs Précédent",
    last12Months: "12 Derniers Mois vs Précédent",
    growthSummary: "Résumé de Croissance",
    driverVehicleMatrix: "Matrice Chauffeur-Véhicule",
    driverVehicleMatrixDesc: "Voir comment chaque chauffeur performe avec différents véhicules",
    driver: "Chauffeur",
    vehicleTotal: "Total Véhicule",
    showingTopDrivers: "Affichage des meilleurs",
    drivers: "chauffeurs",
  },
  lockScreen: {
    sessionLocked: "Session Verrouillée",
    sessionLockedDesc: "La session a été verrouillée",
    unlockSession: "Session déverrouillée",
    passwordPlaceholder: "Entrez votre mot de passe...",
    authPlaceholder: "Authentification...",
    wrongPassword: "Mot de passe incorrect",
    unlock: "Déverrouiller",
    or: "ou",
    logout: "Se Déconnecter",
    lockScreen: "Verrouiller l'Écran",
    inactivityMessage: "Verrouillé en raison de {{minutes}} minutes d'inactivité",
    inactivityShort: "{{minutes}} min d'inactivité",
    biometricUnlock: "Déverrouiller par Biométrie",
    biometricFailed: "Échec de l'authentification biométrique",
    biometricSuggestion: "Vous pouvez enregistrer le déverrouillage biométrique (empreinte digitale ou reconnaissance faciale) depuis les paramètres de sécurité de votre profil.",
    biometricSecurity: "Sécurité Biométrique",
    biometricDescription: "Déverrouillez rapidement l'écran de verrouillage avec l'empreinte digitale ou la reconnaissance faciale.",
    biometricRegistered: "Biométrie enregistrée avec succès !",
    biometricCancelled: "Enregistrement biométrique annulé",
    biometricDeleted: "Identifiant biométrique supprimé",
    registerBiometric: "Enregistrer la Biométrie",
    addAnotherDevice: "Ajouter un Autre Appareil",
    registeredDevices: "appareil(s) enregistré(s)",
    lastUsed: "Dernière utilisation",
    registered: "Enregistré",
    dismiss: "Fermer",
    idleTimeout: "Délai de verrouillage",
    idleTimeoutDesc: "L'écran se verrouille automatiquement après inactivité",
  },
  settings: {
    securitySettings: "Paramètres de Sécurité",
    lockScreenSettings: "Verrouillage de session et paramètres de sécurité",
    minutes: "minutes",
    idleTimeoutDescription: "L'écran se verrouillera automatiquement lorsque l'utilisateur est inactif pendant la durée spécifiée. (1-120 minutes)",
  },
  email: {
    mandrill_api_key: "Clé API Mandrill",
    smtp_pass: "Mot de passe SMTP",
  },
  sms: {
    api_key: "Clé API SMS",
  },
  whatsapp: {
    api_key: "Clé API WhatsApp",
  },
  planning: {
    days: {
      0: "Lundi", 1: "Mardi", 2: "Mercredi", 3: "Jeudi",
      4: "Vendredi", 5: "Samedi", 6: "Dimanche"
    },
    copyDayToNext: "Copier {{day}} → {{next}}",
    spreadDayTitle: "Étendre {{day}} aux {{remaining}} jours restants (hors dimanche)",
    prevWeek: "Semaine précédente",
    nextWeek: "Semaine suivante",
    copyFromPrevWeek: "Copier depuis la semaine précédente",
    depotAndRoutes: "Dépôt & Tournées",
    deleteWeekTitle: "Supprimer toutes les affectations de cette semaine",
    firmDepotRoute: "Société / Dépôt / Tournée",
    viewConflicts: "Voir les conflits",
    boardCanvas: {
      title: "Tableau de planification",
      zoomIn: "Zoom avant",
      zoomOut: "Zoom arrière",
      fitAll: "Ajuster tout",
      preparing: "Préparation…",
      assignmentsCount: "{{count}} affectations",
      downloadExcelTitle: "Télécharger Excel coloré",
      open: "Ouvrir",
      noAssignmentsWeek: "Aucune affectation cette semaine",
      moreFirms: "+{{count}} sociétés — utilisez \"Ouvrir\" pour les détails",
      dayCol: "Jour",
      depot: "DÉPÔT",
      excelDownloaded: "Excel coloré W{{week}} téléchargé",
      downloadFailed: "Téléchargement échoué",
      dataLoadFailed: "Échec du chargement des données",
      legend: { depot: "DÉPÔT", assignment: "Affectation", driver: "Chauffeur", day: "Jour" },
      legendToggle: "Légende"
    }
  },
  dpd: {
    common: {
      firm: "Entreprise", date: "Date", dateFrom: "Du", dateTo: "Au",
      refresh: "Actualiser", loading: "Chargement...", noData: "Aucune donnée",
      total: "Total", search: "Rechercher...", clear: "Effacer", cancel: "Annuler",
      delete: "Supprimer", preview: "Aperçu", page: "Page", pageSize: "Taille de page",
      first: "Premier", last: "Dernier", prev: "Préc.", next: "Suiv.",
      preset7: "7 derniers jours", preset14: "14 derniers jours", preset30: "30 derniers jours",
      preset90: "90 derniers jours", preset3: "3 derniers jours",
      day: "jour", tour: "Tournée", courier: "Coursier", subco: "Subco",
      packages: "Colis", stops: "Arrêts", km: "Km", hours: "Heures",
      retour: "Retour", deliveryRate: "Taux de livraison", successRate: "Réussite %",
      fastTrans: "Fast-Trans", ownCompany: "Votre Entreprise", activeDays: "Jours Actifs"
    },
    dailySummary: {
      title: "DPD Résumé Quotidien", subtitle: "Tournées DPD Fast-Trans — coursier, arrêts, colis et distance",
      ingestFromMail: "Importer depuis Archive Mail",
      cols: { tour: "Tournée", courier: "Coursier", chassis: "Plaque/Châssis", stops: "Arrêts", parcels: "Colis", retourPlan: "Plan Retour", km: "Km", duration: "Durée", start: "Début", end: "Fin", endpoint: "Endpoint" },
      stats: { tours: "Tournées", totalStops: "Arrêts Totaux", delivered: "Livrés", totalKm: "Km Totaux", retour: "Retour" }
    },
    driverPerformance: {
      title: "DPD Performances Coursier & Tournée",
      subtitle: "Colis, taux de livraison, retours et distance par {{group}} sur la période.",
      groupCourier: "Par Coursier", groupTour: "Par Tournée",
      trendTitle: "Tendance Hebdomadaire (8 dernières semaines)",
      cols: { courier: "Coursier", tour: "Tournée", days: "Jours", tours: "Tournées", couriers: "Coursiers", parcels: "Colis", stops: "Arrêts", retour: "Retour", deliveryPct: "Livr. %", km: "Km", hours: "Heures", avgKmDay: "Moy Km/Jour" },
      colorLegend: "Échelle de couleur :",
      empty: "Aucune donnée pour la période sélectionnée."
    },
    consolidated: {
      title: "DPD Rapport Opérationnel Quotidien Consolidé",
      subtitle: "Performance consolidée Fast-Trans : taux de réussite par ligne, causes racines des retours et analyse managériale automatique.",
      modeSingle: "Jour Unique", modeRange: "Plage de Dates",
      kpi: {
        parcelsPlan: "Colis en Livraison", tourSum: "Total de {{count}} lignes", tourSumRange: "{{tours}} lignes × {{days}} jours",
        deliveredSA13: "Livraison Réussie (SA13)", deliveryRatio: "Livraison : {{rate}}%",
        returnedSA23: "Livraison Échouée (SA23)", returnRate: "Retour : {{rate}}%",
        pickupSA15: "Ramassés (SA15)", pickupSubtitle: "Ramassages Coursiers",
        ftRetour: "Retour Fast Trans", scannedOthers: "Scannés au dépôt ({{others}} autres)",
        totalKm: "Km Totaux", kmPerParcel: "Moy {{v}} km/colis",
        totalHours: "Heures Totales", hoursPerTour: "Moy {{v}} h/ligne",
        activeLines: "Lignes Actives", activeLinesSubtitle: "Fast-Trans"
      },
      tourTableTitle: "Fast Trans — Performance de Clôture Ligne & Chauffeur",
      tourCols: { date: "Date", line: "Ligne", driverChassis: "Chauffeur & Châssis", plan: "Plan", sa13: "SA13", sa23: "SA23", sa15: "SA15", distance: "Distance", durationOFD: "Temps (OFD)", parcelsPerHour: "Colis/h", endpoint: "Endpoint", successPct: "Réussite %" },
      reasonBreakdown: "Répartition Codes Retour (Fast Trans)",
      reasonCols: { code: "Code", label: "Description", count: "Nb", pct: "%", chart: "Répartition" },
      retourDetayTitle: "Détail Retour : Destinataire, Adresse et Motif",
      retourDetayHeader: "({{ft}} colis Fast-Trans{{othersText}})",
      retourOthersText: " · {{n}} autres subcos",
      retourCols: { packageNo: "N° Colis", firm: "Firme", line: "Ligne", recipient: "Destinataire & Adresse", postcode: "CP", weight: "Kg", reason: "Cause Racine", time: "Heure" },
      insightsTitle: "Analyses Managériales & Actions Auto",
      shownRange: "Affiché : {{from}} - {{to}} / {{total}}",
      noTourData: "Pas de données de tournée pour cette date."
    },
    monthlyInvoice: {
      title: "DPD Résumé Mensuel de Facturation",
      subtitle: "Colis mensuels, codes produit et primes par tournée depuis les fichiers Subco Details Fast-Trans.",
      month: "Mois",
      kpi: { totalParcels: "Colis Totaux", reliability: "Fiabilité Moy.", basePay: "Basisvergoeding", netPay: "Paiement Net",
             daysAndTours: "{{days}} jours / {{tours}} tournées", bonusMalus: "Bonus {{bonus}} / Malus {{malus}}", netSubtitle: "Base + Bonus − Malus" },
      breakdownTitle: "Répartition Mensuelle par Tournée", productTitle: "Répartition par Code Produit (Total Mensuel)",
      productHint: "Codes : 03D=Standard, 03XD=Extra, 03SD=Samedi, 04DAD/04DAV=Weekend, 05MAST=Master, etc.",
      cols: { tour: "Tournée", activeDays: "Jours Actifs", delivered: "Livrés", stops: "Arrêts", pickup: "Pickup", km: "Km", reliabilityPct: "Fiab. %", basePay: "Base (€)", bonus: "Bonus", malus: "Malus", netPay: "Net (€)", totalRow: "Total" },
      empty: "Aucune donnée de facturation pour ce mois. Les Excels Subco Details arrivent par e-mail.",
      sourceFiles: "Source : {{files}}"
    },
    heatmap: {
      title: "DPD Heatmap des Retours",
      subtitle: "Code postal (2 premiers chiffres) × code motif matrice. Révèle les zones problématiques et causes racines.",
      subcoFilter: "Subco (optionnel ex : fast)", ftOnly: "Fast-Trans Seul", clearFilter: "Effacer Filtre",
      stats: { totalRetour: "Retour Total", pcRegion: "Régions CP", reasonCodes: "Codes Motif Distincts" },
      cols: { pcRegion: "CP / Région", total: "Total" },
      legendLow: "Bas → Haut", legendMax: "Max : {{n}} colis / cellule", legendDensity: "Densité :",
      reasonLegendTitle: "Description des Codes Motif",
      empty: "Aucune donnée de retour pour les filtres sélectionnés."
    },
    subcoComparison: {
      title: "DPD Comparaison Subco",
      subtitle: "Compare Fast-Trans aux autres subcos sur le volume de retour et causes. Les données de retour couvrent tous les subcos ; livraison & km uniquement Fast-Trans.",
      ftBlockTitle: "Fast-Trans (Votre Entreprise) — {{days}} jours",
      metrics: { delivered: "Livrés", retour: "Retour", success: "Taux de Réussite", totalKm: "Km Totaux" },
      stats: { totalRetour: "Retour Total", activeSubco: "Subcos Actifs", activeDays: "Jours Actifs" },
      trendTitle: "Tendance Hebdomadaire Retour — Top 6 Subcos",
      cols: { subco: "Subco", retour: "Retour", share: "Part %", chart: "Graphique", tours: "Tournées", activeDays: "Jours Actifs", avgDay: "Moy/Jour", weight: "Poids (kg)" },
      rootCauses: "Top Causes Racines :",
      empty: "Aucune donnée de retour pour la période.",
      hint: "Cliquez une ligne pour voir les codes motif de retour les plus fréquents de ce subco."
    },
    retourReport: {
      title: "DPD Rapport Retour",
      subtitle: "Colis non livrés — pagination côté serveur + filtres avancés",
      filters: { tour: "Tournée (Q10)", subco: "Subco", reason: "Code Motif (25)", pc: "CP (35)", q: "Rechercher colis/destinataire..." },
      totalPackages: "{{count}} colis", filtered: "(filtré)", clearAll: "Effacer Filtres",
      aggTitle: "Par {{title}} ({{count}})",
      cols: { packageNo: "N° Colis", tour: "Tournée", time: "Heure", reason: "Motif", weight: "Kg", pc: "CP", recipient: "Destinataire", subco: "Subco" },
      shownRange: "Affiché : {{from}} - {{to}} / {{total}}",
      empty: "Aucun retour ne correspond aux filtres."
    },
    courierMapping: {
      title: "DPD Association Coursier",
      subtitle: "Associez les noms de coursier de DPD RouteDataLog aux employés HR réels. Acceptez les suggestions floues ou choisissez manuellement.",
      autoMinLabel: "Score d'auto-match ≥", autoApply: "Appliquer Auto",
      stats: { total: "Coursiers Totaux", mapped: "Associés", unmapped: "Non Associés" },
      cols: { courier: "Nom Coursier DPD", status: "Statut", match: "Employé Associé / Suggestions", manual: "Choix Manuel", action: "Action" },
      statusMapped: "Associé", statusUnmapped: "Aucun",
      noSuggestion: "Pas de suggestion — choisir manuellement",
      pickEmployee: "Choisir employé...", searchPlaceholder: "Rechercher nom ou e-mail...",
      noEmployee: "Aucun employé trouvé.",
      remove: "Retirer", empty: "Aucun coursier trouvé dans DPD RouteDataLog.",
      hint: "💡 Score fuzzy : 100 = correspondance complète, 50 = une partie. Auto-appliquer sauve les matches {{score}}+."
    },
    fileCategories: {
      title: "DPD Catégories de Fichiers",
      subtitle: "Parcourez les pièces jointes DPD par type & importez par fichier ou catégorie. Les doublons sont ignorés ; les fichiers junk (image, signature) sont filtrés.",
      ingestAll: "Tout Importer", ingestCat: "Importer Cette Catégorie", deleteAll: "Tout Supprimer",
      resetAll: "Réinitialiser Tous les Rapports & Analyses", resetCat: "Réinitialiser Cette Catégorie",
      resetAllTitle: "Réinitialiser toutes les données DPD ?",
      resetAllBody: "Tous les rapports et analyses seront supprimés (l'archive mail est préservée). Vous pouvez ensuite utiliser « Tout Importer » pour retraiter les Excels.",
      resetCatTitle: "Réinitialiser la catégorie {{cat}} ?",
      resetCatBody: "Toutes les lignes analysées et les logs d'ingestion pour cette catégorie seront supprimés. L'archive mail est conservée ; vous pouvez réimporter.",
      resetDone: "Réinitialisation terminée : {{n}} enregistrements supprimés",
      resetFailed: "Réinitialisation échouée",
      mailDate: "Date Mail",
      totalSummary: "{{files}} fichiers au total, {{cats}} catégories",
      countFiles: "{{n}} fichiers", countIngested: "({{n}} importés)",
      cols: { file: "Fichier", date: "Date", mailDate: "Date Mail", archived: "Archivé", from: "De", status: "Statut", action: "Action" },
      excludePlaceholder: "Exclure par nom de fichier (ex. HYK, test)",
      filteredHint: "{{n}} fichiers filtrés",
      sort: {
        mailDesc: "Date Mail (Récent → Ancien)",
        mailAsc: "Date Mail (Ancien → Récent)",
        arcDesc: "Archivé (Récent → Ancien)",
        arcAsc: "Archivé (Ancien → Récent)",
      },
      status: { rows: "{{n}} lignes", waiting: "En attente", junk: "Junk" },
      toast: {
        alreadyIngested: "Déjà importé",
        importedRows: "{{n}} lignes importées",
        importFailed: "Import échoué",
        bulkResult: "{{ingested}} fichiers traités",
        bulkAlready: "{{n}} déjà importés", bulkJunk: "{{n}} junk ignorés", bulkUnknown: "{{n}} inconnus ignorés", bulkErrors: "{{n}} erreurs",
        bulkFailed: "Import en masse échoué",
        previewFailed: "Aperçu échoué",
        deleted: "Fichier supprimé", deleteFailed: "Suppression échouée",
        junkDeleted: "{{done}} fichiers junk supprimés"
      },
      dialog: {
        deleteFileTitle: "Supprimer le fichier ?",
        deleteFileBody: "{{filename}} sera supprimé définitivement. Action irréversible.",
        deleteJunkTitle: "Supprimer {{n}} fichiers junk ?",
        deleteJunkBody: "Action irréversible. Fichiers retirés de l'archive mail et S3."
      },
      emptyState: "Aucun fichier DPD dans l'archive mail.",
      emptyHint: "Définissez une règle pour dpd.be dans Paramètres → Règles Archive Mail."
    },
    alerts: {
      widgetTitle: "Alertes DPD",
      severityHigh: "haute", severityMedium: "moyenne", severityLow: "basse",
      badges: { high: "Haute", medium: "Moyenne", low: "Basse" },
      types: { lowDelivery: "Livraison Faible", highRetour: "Retour Élevé" },
      detailLink: "Détails →",
      moreAlerts: "+{{n}} alertes de plus — "
    },
    analytics: {
      title: "DPD Analytique & Perspectives",
      subtitle: "Fast-Trans exclusif — tendances annuelles, comparaisons, prévisions et résumé IA",
      year: "Année", refresh: "Actualiser", loading: "Calcul des analyses…",
      empty: "Aucune donnée Fast-Trans pour cette année. Importez d'abord les Excels.",
      kpi: {
        packages: "Total Colis", retour: "Total Retour", deliveryRate: "Taux de Livraison",
        activeDays: "Jours Actifs", activeCouriers: "Coursiers Actifs", activeTours: "Tournées Actives", avgDaily: "Moy. Journalière",
      },
      yoy: {
        title: "Comparaison Annuelle ({{prev}} vs {{cur}})",
        packages: "Volume Colis", retour: "Nombre Retours", deliveryRate: "Taux Livraison", couriers: "Coursiers Actifs",
      },
      monthly: { title: "Tendance Mensuelle", subtitle: "Volume livraison/retour des 24 derniers mois", packages: "Colis", retour: "Retour", deliveryPct: "Livraison %" },
      dow: { title: "Motif Jour de la Semaine", subtitle: "Quels jours sont critiques — volume & taux de succès" },
      reasons: { title: "Tendance Motifs Retour", topTitle: "Motifs de Retour Les Plus Fréquents", share: "Part" },
      drivers: {
        title: "Classement Coursiers & Recommandations",
        subtitle: "Score = 60% livraison + 30% volume + 10% régularité",
        rank: "Rang", courier: "Coursier", score: "Score", packages: "Colis", retour: "Retour", deliveryPct: "Livraison %", days: "Jours", recommendation: "Recommandation",
      },
      forecast: {
        title: "Prévision", nextMonthRetour: "Estimation Retours Mois Prochain", nextMonthPackages: "Volume Colis Attendu",
        based: "Basé sur les {{n}} derniers mois", trend: { up: "En hausse", down: "En baisse", flat: "Stable" },
      },
      insights: { title: "Perspectives Automatiques", subtitle: "Motifs extraits des chiffres" },
      ai: { title: "Analyse (Claude Sonnet)", subtitle: "Brief exécutif — évaluation en langage naturel", loading: "Génération de l'analyse…", error: "Analyse indisponible" },
      pdf: { export: "Télécharger PDF", generating: "Génération du PDF…", done: "PDF prêt", failed: "Échec de la génération PDF", fileName: "DPD-Analytique-{{year}}.pdf" },
      driver: { modalTitle: "Détail Coursier — {{name}}", coaching: "Note de Coaching Personnel", vsAvg: "vs Moy. Entreprise", rank: "Rang", personalTrend: "Tendance Mensuelle Personnelle", yourReasons: "Vos Motifs de Retour", close: "Fermer", clickHint: "Cliquez sur la ligne pour les détails" },
    }
  }
};

export default fr;
